import React, {useRef, useCallback, useEffect, useState, memo} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import EditIcon from '@material-ui/icons/Edit';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import HistoryIcon from '@material-ui/icons/History';
import AddToPhotosIcon from '@material-ui/icons/AddToPhotos';
import DeleteIcon from '@material-ui/icons/Delete';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import SortIcon from '@material-ui/icons/Sort';
import SortByAlphaIcon from '@material-ui/icons/SortByAlpha';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import {
  Box,
  Card,
  CardHeader,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormHelperText,
  Grid,
  InputLabel,
  List,
  ListItem,
  MenuItem,
  TextField,
  Typography
} from '@material-ui/core';
import {
  LinearProgressWithLabel,
  EnhancedIconButton,
  ProgressDialog,
  TextDialog,
  DraggableDialog,
  PromptDialog,
  DenseDivider,
  IconToolBar,
  SlimScrollbar,
  ToolBarButton,
  ArrowTooltip,
  EnhancedTable,
  DropdownWithLabel,
  NumberFieldWithLabel,
  CheckboxWithLabel,
  FileWithLabel,
  FolderWithLabel,
  NumberField,
  DraggableList,
  TextWithLabel
} from '../components';
import { createStyles, makeStyles, Theme, useTheme } from "@material-ui/core/styles";
import {
  dialog,
  ipcRenderer,
  fs,
  getTemporaryFile,
  shell,
  tempDirectoryPath,
  registerEvent,
  fse
} from '../electron-modules';
import { changeSwitched } from "../redux/settings-slice";
import slash from 'slash';
import { PythonExecutable } from '../executable';
import LocalScene from '../viewer/js/projections';
import { FixedSizeList } from "react-window";
import path from 'path';
import {
  addAsset,
  AssetType,
  deleteAsset,
  getCameraFileAssets,
  getPointCloudAssets,
  selectAllAssets
} from '../redux/assets-slice';
import { asyncTimeout, useAssetTools } from '../utilities';
import DialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import Button from '@material-ui/core/Button/Button';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import Select from '@material-ui/core/Select/Select';
import { nanoid } from '@reduxjs/toolkit';
import { throttle } from 'throttle-debounce';
import { selectProjectName } from '../redux/project-slice';
import Paper from '@material-ui/core/Paper';
import { DropResult } from 'react-beautiful-dnd';
import { toast } from '../app';
import clsx from 'clsx';
import {
  ImageLabel,
  LabelCategory,
  textToColor,
  getClassFromAlias,
  getNameFromClass,
  TrainingAreaLabel
} from '../viewer/js/labelling';
import { useTranslation } from 'react-i18next';
import {
  drawingFilter,
  DXFModelFilter,
  getCombinedExtension,
  labelFilter,
  modelFilter,
  SHPModelFilter
} from '../file-extensions';
import {
  useDialog,
  useUniqueProjectID,
  useViewer,
  useActiveTool
} from '../hooks';
import {selectDefaultFolder} from "../redux/folders-slice";
import { useTableState } from '../hooks/use-table-state';
import { writeToString } from 'fast-csv';

enum LabelImportType {
  Ignore="__ignore",
  Default="__default"
}

const labelHeight = 53;
const geometryLimit = 1000;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleClose: {
      position: 'absolute',
      right: theme.spacing(0),
      color: theme.palette.grey[500],
    },
    titleInfo: {
      position: 'absolute',
      right: theme.spacing(4),
      marginTop: theme.spacing(0),
      color: theme.palette.grey[500],
    },
    titleMin: {
      position: 'absolute',
      right: theme.spacing(4),
      marginTop: theme.spacing(-1),
      color: theme.palette.grey[500],
    },
    userWarning: {
      padding: theme.spacing(3)
    },
    marginTop: {
      marginTop: theme.spacing(2)
    },
    box: {
      padding: theme.spacing(4)
    },
    formControl: {
      width: '100%'
    },
    listContent: {
      margin: theme.spacing(0),
      padding: theme.spacing(0)
    },
    categoryName: {
      flex: 1
    },
    success: {
      color: theme.palette.success.main
    },
    warning: {
      color: theme.palette.warning.main
    },
    error: {
      color: theme.palette.error.main
    },
    info: {
      color: theme.palette.info.main
    },
    folderList: {
      padding: "0px",
      overflow: "auto",
      flex: 1,
      alignItems: "center",
      justifyContent: "center"
    },
    headerTitle: {
      fontWeight: "bold",
      cursor: "pointer"
    },
    cardHeader: {
      padding: theme.spacing(1)
    },
    cardButtons: {
      marginTop: 0,
      alignSelf: "center"
    },
    labelFixedHeight: {
      height: `${labelHeight}px`
    },
    labelParent: {
      flex: 1,
      userSelect: "none",
      display: "flex",
      flexDirection: "column"
    },
    labelTitleWarning: {
      color: theme.palette.warning.main
    },
    labelTitleError: {
      color: theme.palette.error.main
    },
    classificationText: {
      fontSize: "0.6rem"
    },
    card: {
      margin: theme.spacing(2),
      marginTop: theme.spacing(0),
      padding: theme.spacing(1),
      userSelect: "none"
    },
    progressToolbar: {
      display: "flex",
      marginLeft: "12px",
      marginRight: "12px"
    },
    toolbarLinear: {
      margin: "auto 12px"
    },
    toolbarProgressCenter: {
      top: "50%",
      height: "6px",
      marginTop: "-3px"
    },
    downloadMargin: {
      marginTop: theme.spacing(1)
    },
    downloadResourceDialog: {
      paddingTop: theme.spacing(2.5),
      paddingBottom: theme.spacing(2.5),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4)
    },
    mixedDataWarning: {
      padding: theme.spacing(2.0),
      color: theme.palette.warning.main
    },
    tableDropdown: {
      fontSize: "0.875rem",
      width: "100%"
    },
    checkBoxWithLabel: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    toggleOptionFlex: {
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    toggleOptionCheckbox: {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5)
    },
    mappingMargin: {
      marginBottom: "3px"
    },
    checkBoxParent: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    },
    paddingBottom: {
      paddingBottom: theme.spacing(3),
      display: "block"
    },
    captionPadding: {
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(0.5),
      display: "block"
    },
    paddingBottomAndTop: {
      paddingBottom: theme.spacing(3),
      paddingTop: theme.spacing(3),
      display: "block"
    },
    paddingBottomAndTopMinimal: {
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
      display: "block"
    },
    fileButtonDiv: {
      paddingTop: theme.spacing(1),
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    outputFolder: {
      paddingBottom: theme.spacing(4)
    },
    selectDivider: {
      margin: theme.spacing(0.5),
      opacity: 0.2
    },
    infoLabel: {
      fontWeight: "bold",
      paddingRight: theme.spacing(0.5)
    },
    flexPaper: {
      flex: 1,
      margin: 16,
      minWidth: 350
    },
  }),
);

const Label = (props) => {
  const label = props.label as ImageLabel;
  const {index, isScrolling, style, labelName, isSceneLabel} = props;

  const classes = useStyles();
  const {viewer} = useViewer();
  const {t} = useTranslation();

  const [getInfo, setGetInfo] = useState(false);

  const selected = label.selected;
  const completed = label.completed;
  const isTrainingLabel = label instanceof TrainingAreaLabel;

  const scoreClass = () => {
    let scoreValidity = classes.success;
    if (label.score < 0.9) {
      scoreValidity = classes.warning;
    }
    if (label.score < 0.7) {
      scoreValidity = classes.error;
    }
    return scoreValidity;
  };

  const getInfoLabel = () => {
    setGetInfo(true);
  };

  const deleteLabel = (id) => {
    viewer?.deleteLabel(id);
  };

  const zoomToLabel = (id) => {
    viewer?.zoomToLabel(id);
  };

  const unHighlight = (id) => {
    viewer?.unHighlight(id);
  };

  return (
    <ListItem selected={selected} style={style} className={classes.labelFixedHeight}>
      <div className={classes.labelParent}>
        {/** Label number */}
        <Typography variant="caption" className={clsx("", {
          [classes.labelTitleError]: !label.valid,
          [classes.labelTitleWarning]: label.valid && label.highlighted
        })}>
          {`${labelName} #${index + 1} (${label.numPoints})`}
        </Typography>

        {/** Classification score */}
        {!isTrainingLabel && (<div>
          <Typography variant="caption" className={classes.classificationText}>
            {t('labels.classification-score')}:&nbsp;
          </Typography>

          <Typography variant="caption" className={clsx(scoreClass(), classes.classificationText)}>
            {label.score.toFixed(2)}
          </Typography>
        </div>)}
      </div>

      {isScrolling && (<React.Fragment>
        <Typography variant="caption">
          Loading...
        </Typography>
      </React.Fragment>)}

      {!isScrolling && (<React.Fragment>

        {/*Classification Score*/}
        <EnhancedIconButton
          visible={completed && !isTrainingLabel}
          title={t('labels.classification-score')}
        >

        </EnhancedIconButton>

        {/* Warning on Label */}
        <EnhancedIconButton
          title={t('labels.name-is-invalid-will-not-be-exported', {
            name: labelName
          })}
          visible={completed && (!label.valid)}
        >
          <WarningIcon fontSize="small" className={classes.error}/>
        </EnhancedIconButton>

        {/* Highlighted Label */}
        <EnhancedIconButton
          title={t('labels.name-was-highlighted-click-to-remove-highlight', {
            name: labelName
          })}
          visible={completed && (label.highlighted)}
          onClick={() => {
            unHighlight(label.id);
          }}
        >
          <PriorityHighIcon fontSize="small" className={classes.warning}/>
        </EnhancedIconButton>

        {/* Info on Label */}
        <EnhancedIconButton
          title={t('labels.name-information', {
            name: labelName
          })}
          visible={completed && !isTrainingLabel}
          onClick={() => getInfoLabel()}
        >
          <InfoIcon fontSize="small"/>
        </EnhancedIconButton>

        {/* Zoom to extent */}
        <EnhancedIconButton
          title={t('labels.zoom-to-name', {
            name: labelName
          })}
          visible={completed}
          onClick={() => {
            zoomToLabel(label.id);
          }}
        >
          <ZoomInIcon fontSize="small"/>
        </EnhancedIconButton>

        {/* Delete Label */}
        <EnhancedIconButton
          title={t('labels.delete-name', {
            name: labelName
          })}
          onClick={() => {
            deleteLabel(label.id);
          }}
        >
          <DeleteIcon fontSize="small"/>
        </EnhancedIconButton>

        {/* Label Info */}
        <GetInfoWindow
          open={getInfo}
          setOpen={setGetInfo}
          label={label}
          index={index + 1}
          isSceneLabel={isSceneLabel}
        />
      </React.Fragment>)}
    </ListItem>
  );
};

const CategoryContent = (props) => {
  const category = props.category as LabelCategory;
  const {labelName, idx, isSceneLabel} = props;

  const classes = useStyles();
  const listRef = useRef(null);

  const scrollingDivLength = category.labels.length;
  const useScrollingDiv = scrollingDivLength > 5;
  const scrollingDivHeight = Math.min(scrollingDivLength*labelHeight, 250);

  useEffect(() => {
    if (listRef) {
      if (listRef.current){
        listRef.current.scrollToItem(idx);
      }
    }
  }, [idx, listRef]);

  return (<React.Fragment>
    {/* Use normal list for small labels list */}
    {!useScrollingDiv && (<React.Fragment>
      <List className={classes.folderList}>
        {category.labels.map((label, index) =>
          <Label
            key={label.id}
            isScrolling={false}
            label={label}
            index={index}
            labelName={labelName}
            isSceneLabel={isSceneLabel}
          />
        )}
      </List>
    </React.Fragment>)}

    {/* Use scrolling list for large amounts of labels */}
    {useScrollingDiv && (<React.Fragment>
      <FixedSizeList
        ref={listRef}
        useIsScrolling
        className={classes.formControl}
        height={scrollingDivHeight}
        itemCount={scrollingDivLength}
        itemSize={labelHeight}
      >
        {({index, isScrolling, style}) => (
          <Label
            key={category.id}
            style={style}
            isScrolling={isScrolling}
            label={category.labels[index]}
            index={index}
            labelName={labelName}
            isSceneLabel={isSceneLabel}
          />
        )}
      </FixedSizeList>
    </React.Fragment>)}
  </React.Fragment>);
};

const CategoryExpand = (props) => {
  const {setExpanded, expanded} = props;

  const {t} = useTranslation();

  return (<EnhancedIconButton
    title={expanded? t('general.collapse') : t('general.expand')}
    onClick={(event) => {
      event.stopPropagation();
      setExpanded(!expanded);
    }}
  >
    {expanded && <ExpandLessIcon fontSize="small"/>}
    {!expanded && <ExpandMoreIcon fontSize="small"/>}
  </EnhancedIconButton>);
};

const TrainingArea = (props) => {
  const {trainingArea} = props;

  const classes = useStyles();
  const {viewer} = useViewer();
  const {t} = useTranslation();

  const [expanded, setExpanded] = useState(false);
  const [deletePrompt, setDeletePrompt] = useState(false);

  const clearTrainingArea = () => {
    // Delete all areas
    [...trainingArea.labels].forEach(label => {
      viewer?.deleteLabel(label.id);
    });

    setDeletePrompt(false);
  };

  const addThenExpand = () => {
    addLabel();
    setExpanded(true);
  };

  const addLabel = () => {
    viewer?.addTrainingAreaLabel();
  };

  const addNewLabelDisabled = viewer?.labelSelected();
  const addNewlabelTooltip = t('labels.add-new-training-area');

  return (
    <React.Fragment>
      <Card className={classes.card}>
        {/* Header */}
        <CardHeader
          className={classes.cardHeader}
          classes={{
            action: classes.cardButtons
          }}
          action={
            <React.Fragment>
              {/* Expand/collapse areas */}
              <CategoryExpand
                setExpanded={setExpanded}
                expanded={expanded}
              />

              {/* Add new area label */}
              <EnhancedIconButton
                title={addNewlabelTooltip}
                disabled={addNewLabelDisabled}
                onClick={() => {
                  addThenExpand();
                }}
              >
                <AddToPhotosIcon fontSize="small"/>
              </EnhancedIconButton>

              {/* Delete Training Area */}
              <EnhancedIconButton
                title={t('labels.clear-all-training-areas')}
                onClick={() => {
                  setDeletePrompt(true);
                }}
              >
                <DeleteIcon fontSize="small"/>
              </EnhancedIconButton>

            </React.Fragment>
          }
          disableTypography={true}
          title={
            <Typography
              variant="body2"
              className={classes.headerTitle}
            >
              {t('labels.training-areas')}
            </Typography>
          }
          subheader={
            <Typography variant="caption">
              {t('labels.total-areas', {
                count: trainingArea.labels.length
              })}
            </Typography>
          }
        />

        {/* Expandable content */}
        {expanded && (<CategoryContent
          category={trainingArea}
          labelName={t('labels.area')}
          idx={0}
        />)}
      </Card>

      <PromptDialog
        open={deletePrompt}
        onCancel={() => setDeletePrompt(false)}
        onSubmit={clearTrainingArea}
        title={t('labels.clear-training-areas')}
        prompt={t('labels.do-you-want-to-remove-all-training-areas')}
        button={t('buttons.delete')}
      />

    </React.Fragment>
  );
};

const Category = (props) => {
  const category = props.category as LabelCategory;
  const {isValidCategory, labelDisabled,
    runTextDetection, isSceneLabel} = props;

  const classes = useStyles();
  const {viewer} = useViewer();
  const {t} = useTranslation();

  const [expanded, setExpanded] = useState(false);
  const [editPrompt, setEditPrompt] = useState(false);
  const [deletePrompt, setDeletePrompt] = useState(false);
  const [sortPrompt, setSortPrompt] = useState(false);
  const [textDetectPrompt, setTextDetectPrompt] = useState(false);
  const [sorted, setSorted] = useState(false);

  const idx = viewer?.getIdxInList(category);

  const formatName = (name) => {
    const maxLength = 22;

    return (name.length > maxLength)
      ? name.substr(0, maxLength - 1) + "..."
      : name;
  };

  const addThenExpand = (categoryID) => {
    addLabel(categoryID);
    setExpanded(true);
  };

  const addLabel = (id) => {
    viewer?.addLabel(id);
  };

  const handleDeleteCategory = () => {
    viewer?.deleteCategory(category.id);
    setDeletePrompt(false);
  };

  const handleEditCategory = (name) => {
    if (!isValidCategory(name)) {
      return;
    }

    viewer?.editCategoryName(category.id, name);
    setEditPrompt(false);
  };

  const runSort = (scoreValue, sortType) => {
    viewer?.sortCategory(category, scoreValue, sortType);
    setSorted(true);
  };

  const undoSort = () => {
    viewer?.undoSort(category);
    setSorted(false);
  };

  useEffect(() => {
    if (idx >= 0) {
      setExpanded(true);
    }
  }, [idx]);


  const addNewLabelDisabled = viewer?.labelSelected();
  const addNewlabelTooltip = t('labels.add-new-label', {
    type: viewer.currentCategory()
  });

  const numLabelsTooltip = t('labels.click-to-undo-sort', {
    count: category.numLabelsAll
  });

  const color = textToColor(category.name);

  return (
    <React.Fragment>
      <Card className={classes.card}>
        {/* Header */}
        <CardHeader
          className={classes.cardHeader}
          classes={{
            action: classes.cardButtons
          }}
          action={
            <React.Fragment>
              {/* Expand/collapse labels */}
              <CategoryExpand
                setExpanded={setExpanded}
                expanded={expanded}
              />

              {/* Detect Text in Class */}
              <EnhancedIconButton
                title={t('labels.detect-text-in-category-labels')}
                visible={isSceneLabel}
                disabled={labelDisabled}
                onClick={() => {
                  setTextDetectPrompt(true);
                }}
              >
                <TextFieldsIcon fontSize="small"/>
              </EnhancedIconButton>

              {/* Sort by Scores */}
              <EnhancedIconButton
                title={t('labels.sort-by-classification-score')}
                onClick={() => {
                  setSortPrompt(true);
                }}
              >
                <SortIcon fontSize="small"/>
              </EnhancedIconButton>


              {/* Edit category name */}
              <EnhancedIconButton
                title={t('labels.edit-name')}
                onClick={() => {
                  setEditPrompt(true);
                }}
              >
                <EditIcon fontSize="small"/>
              </EnhancedIconButton>

              {/* Add new label */}
              <EnhancedIconButton
                title={addNewlabelTooltip}
                disabled={addNewLabelDisabled}
                onClick={() => {
                  addThenExpand(category.id);
                }}
              >
                <AddToPhotosIcon fontSize="small"/>
              </EnhancedIconButton>

              {/* Delete category */}
              <EnhancedIconButton
                title={t('labels.delete-class')}
                onClick={() => {
                  setDeletePrompt(true);
                }}
              >
                <DeleteIcon fontSize="small"/>
              </EnhancedIconButton>

            </React.Fragment>
          }
          disableTypography={true}
          title={
            <Typography
              variant="body2"
              style={{color}}
              className={classes.headerTitle}
              title={category.name}
            >
              {formatName(category.name)}
            </Typography>
          }
          subheader={
            <React.Fragment>
              <Typography
                variant="caption"
              >
                {t('labels.total-labels', {
                  count: category.labels.length
                })}
              </Typography>
              {(sorted) && <ToolBarButton
                title={numLabelsTooltip}
                icon={"fa-undo"}
                onClick={() => undoSort()}
                error
              />}
            </React.Fragment>
          }
        />

        {/* Expandable content */}
        {expanded && (<CategoryContent
          category={category}
          labelName={t('labels.label')}
          idx={idx}
          isSceneLabel={isSceneLabel}
        />)}

      </Card>

      <TextDialog
        clear
        open={editPrompt}
        onCancel={() => setEditPrompt(false)}
        onSubmit={handleEditCategory}
        title={t('labels.edit-class')}
        prompt={t('labels.enter-new-class-name')}
        placeholder={category.name}
        label={t('labels.class-name')}
      />

      <PromptDialog
        open={deletePrompt}
        onCancel={() => setDeletePrompt(false)}
        onSubmit={handleDeleteCategory}
        title={t('labels.delete-class')}
        prompt={t('labels.do-you-want-to-delete-this-class', {
          name: category.name
        })}
        button={t('buttons.delete')}
      />

      <ScoreSortingParameters
        open={sortPrompt}
        setOpen={setSortPrompt}
        category={category}
        runSort={runSort}
        defaultScore={'0.5'}
      />

      <TextDetectionParameters
        open={textDetectPrompt}
        setOpen={setTextDetectPrompt}
        category={category}
        runTextDetection={runTextDetection}
        defaultScore={'0.2'}
      />

    </React.Fragment>
  );
};


const LabelIntersectDialog = (props) => {
  const {open, setOpen, forceInitialProgress, setTrainClassifyExe,
    setTrainClassifyProgress, resetExecutableValues,
    checkTrainingData, pointClouds, categories, setProcessType} = props;

  const classes = useStyles();
  const {viewer} = useViewer();
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const defaultFolder = useSelector(selectDefaultFolder);

  const {addCSVFiles, addPointCloudFiles} = useAssetTools();

  const projectName = useSelector(selectProjectName);
  const [method, setMethod] = useState("label_intersect_v2");
  const [outputPath, setOutputPath] = useState(null);

  const LASfiles = pointClouds.filter(x => x.type === AssetType.LAS);

  const minLasVersion = Math.min(...LASfiles.map(pointCloud => {
    const header = viewer.getLasFileInfo(pointCloud.id);
    return header ? parseFloat(header.attributes.version) : 0;
  }));

  const visibleClouds = LASfiles.filter(x => x.visible);
  const cloudsAvailable = (visibleClouds.length > 0);
  // const mixedData = (LASfiles.length !== pointClouds.length);
  const maxNumClasses = (minLasVersion >= 1.4) ? 255 : 31;
  const availableLasClasses = viewer?.getAvailableClassifications();
  availableLasClasses?.sort(function(a, b) {
    return a - b;
  });

  const defaults = {
    image_sampling_dist: {value: 1, error: false},
    intersection_angle: {value: 10, error: false},
    min_num_matches: {value: 2, error: false},
    position_confidence: {value: "high", error: false},
    max_distance_from_camera: {value: 60, error: false},
    close_label_dist: {value: 1, error: false},
    min_camera_distance: {value: 1, error: false},
    max_camera_distance: {value: 60, error: false},
    max_intersect_distance: {value: 1, error: false},
    cluster_distance: {value: 1, error: false},
    num_matches_required: {value: 3, error: false},
    object_size: {value: 0.5, error: false},
  };

  // Shared parameters
  const [imageSamplingDistance, setImageSamplingDistance] = useState(defaults.image_sampling_dist);

  // Point synthesis parameters
  const [intersectionAngle, setIntersectionAngle] = useState(defaults.intersection_angle);
  const [minNumMatches, setMinNumMatches] = useState(defaults.min_num_matches);
  const [positionConfidence, setPositionConfidence] = useState(defaults.position_confidence);
  const [maxDistanceFromCamera, setMaxDistanceFromCamera] = useState(defaults.max_distance_from_camera);
  const [closeLabelDist, setCloseLabelDist] = useState(defaults.close_label_dist);

  // Ray intersection parameters
  const [minCameraDistance, setMinCameraDistance] = useState(defaults.min_camera_distance);
  const [maxCameraDistance, setMaxCameraDistance] = useState(defaults.max_camera_distance);
  const [maxIntersectDistance, setMaxIntersectDistance] = useState(defaults.max_intersect_distance);
  const [clusterDistance, setClusterDistance] = useState(defaults.cluster_distance);
  const [numMatchesRequired, setNumMatchesRequired] = useState(defaults.num_matches_required);


  // Extract Point Cloud parameters
  const [extractPoints, setExtractPoints] = useState(false);
  const [objSize, setObjSize] = useState(defaults.object_size);
  const [overwrite, setOverwrite] = useState(false);
  const [collapse1, setCollapse1] = useState(true);
  const [collapse2, setCollapse2] = useState(true);
  const [categoryClasses, setCategoryClasses] = useState(null);
  const [ignoreClasses, setIgnoreClasses] = useState(null);

  const getCategoryClasses = (categories) => {
    let categoriesTemp = categories.map((category, index) => {
      let name = category.name;
      let lasClass = getClassFromAlias(name);
      if (lasClass < 0) {
        lasClass = 0;
      }

      return {
        id: nanoid(),
        index: index,
        primary: name,
        secondary: lasClass.toString(),
        error: false,
        min: 0,
        max: maxNumClasses,
        step:1,
      };
    });
    setCategoryClasses([...categoriesTemp]);
  };

  const getIgnoreClasses = () => {
    let ignoreTemp = availableLasClasses?.map((classification, index) => {
      const name = getNameFromClass(classification);
      return {
        id: nanoid(),
        classification: classification,
        index: index,
        name: name,
        value: false
      };
    });
    if (ignoreTemp) {
      setIgnoreClasses([...ignoreTemp]);
    }
  };

  const updateCategoryNumbers = (data) => {
    let categoriesTemp = [...categoryClasses];
    categoriesTemp[data.index].secondary = data.value;
    categoriesTemp[data.index].error = data.error;
    setCategoryClasses([...categoriesTemp]);
  };

  const updateIgnoreClasses = (index, checked) => {
    let ignoreTemp = [...ignoreClasses];
    ignoreTemp[index].value = checked;
    setIgnoreClasses([...ignoreTemp]);
  };

  const onDragEnd = ({ destination, source }: DropResult) => {
    if (!destination) return;

    let rowsTemp = [...categoryClasses];
    const [removed] = rowsTemp.splice(source.index, 1);
    rowsTemp.splice(destination.index, 0, removed);
    rowsTemp.forEach((row, index) => row.index=index);

    setCategoryClasses([...rowsTemp]);
    return;
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    runIntersection();
    setOpen(false);
  };

  const runIntersection = async () => {
    const jsonData = viewer?.labelObject();
    if (!checkTrainingData(jsonData)) {
      return false;
    }

    const tempCocoPath = getTemporaryFile("3dl");
    const csvEncompassPath = getTemporaryFile('csv');


    try {
      // Write COCO file to temp path
      let text = JSON.stringify(jsonData, null, 2);
      await fse.writeFile(tempCocoPath, text);
    } catch(err) {
      console.log(err);
      toast.error(t("toast.labels-export-failed"));
      return;
    }

    try {
      // Export cameras to csv
      const cameras = viewer.activeImages();
      const rows = viewer.getCameraRowsCSV(cameras);
      const content = await writeToString(rows);
      await fse.writeFile(csvEncompassPath, content);
    } catch {
      toast.error(t("toast.labels-export-failed"));
      return;
    }

    let exe = new PythonExecutable();

    // Shared parameters
    let commands = [
      "-p", method,
      "--csv_image_file", csvEncompassPath,
      "--coco_data_file", tempCocoPath,
      "--output_folder", outputPath,
      "--project_name", projectName,
      "--image_sampling_dist", imageSamplingDistance.value
    ];

    // Point synthesis parameters
    if (useFunctionV1) {
      commands = [
        ...commands,
        "--intersection_angle", intersectionAngle.value,
        "--min_num_matches", minNumMatches.value,
        "--position_confidence", positionConfidence.value,
        "--max_distance_from_camera", maxDistanceFromCamera.value,
        "--close_label_dist", closeLabelDist.value
      ];
    }

    // Ray intersection parameters
    if (useFunctionV2) {
      commands = [
        ...commands,
        "--min_camera_distance", minCameraDistance.value,
        "--max_camera_distance", maxCameraDistance.value,
        "--max_intersect_distance", maxIntersectDistance.value,
        "--cluster_distance", clusterDistance.value,
        "--num_matches_required", numMatchesRequired.value,
      ];
    }

    if (extractPoints) {
      const classesToIgnore = ignoreClasses.filter(ic => ic.value).map(ic => {
        return ic.classification;
      });

      const categoryClassesNames = categoryClasses.map(category => {
        return category.primary;
      });

      const categoryClassesNums = categoryClasses.map(category => {
        return category.secondary;
      });

      commands = [
        ...commands,
        "--find_in_lidar", visibleClouds.map(cloud=>cloud.path),
        "--max_obj_size", objSize.value,
        "--ignore_classes", classesToIgnore,
        "--overwrite_las", (overwrite) ? "True" : "False",
        "--label_class_names", categoryClassesNames,
        "--label_class_nums", categoryClassesNums,
        "--units", LocalScene.dataProjectionUnits
      ];
    }

    forceInitialProgress();
    setTrainClassifyExe(exe);

    toast.success(t("toast.labels-position-submit"));

    let successEstimate = false;
    let successLabelInPC = false;
    let successCombine = false;
    let successConvert = false;
    let convertAttempted = false;
    let successLasWritten = false;
    let lasOutputPath;
    let csvOutputPaths=[];

    exe.run({
      command: commands,
      saveLogs: true,
      onLine: async jsonData => {
        if (!jsonData) {
          return;
        }

        if (jsonData.position_estimate_progress) {
          setTrainClassifyProgress(jsonData.position_estimate_progress);
          setProcessType(t("labels.label-process-export"));
        } else if (jsonData.positions_found) {
          successEstimate = true;
          toast.success(t("toast.labels-position-found", {
            count: jsonData.positions_found
          }));
        } else if (jsonData.csvs_written) {
          csvOutputPaths = jsonData.csvs_written;
          await addCSVFiles(csvOutputPaths, defaultFolder.id);

        } else if (jsonData["Locate Points in Labels"]) {
          setTrainClassifyProgress(jsonData["Locate Points in Labels"]);
          setProcessType(t("labels.label-process-extract-points"));
        } else if (jsonData.labels_found_pointcloud) {
          successLabelInPC = true;
          toast.success(t("toast.labels-points-found", {
            count: jsonData.labels_found_pointcloud
          }));
        } else if (jsonData.combine_las) {
          setTrainClassifyProgress(jsonData.combine_las);
          setProcessType(t("labels.label-process-combine_pointcloud"));
        } else if (jsonData.combine_las_complete) {
          successCombine = true;
          toast.success(t("toast.labels-points-found", {
            count: jsonData.combine_las_complete
          }));
        } else if (jsonData.las_to_3dp) {
          convertAttempted = true;
          setTrainClassifyProgress(jsonData.las_to_3dp);
          setProcessType(t("labels.label-process-convert-pointcloud"));
        } else if (jsonData.las_to_3dp_success) {
          successConvert = true;
          toast.success(t("toast.labels-pointcloud-converted"));
        } else if (jsonData.writing_las) {
          setTrainClassifyProgress(jsonData.writing_las);
          setProcessType(t("labels.label-process-writing-las"));
        } else if (jsonData.las_written) {
          successLasWritten = true;
          lasOutputPath = jsonData.las_written;
        }
      },
      onClose: async () => {
        if (successEstimate) {
          toast.success(t("toast.labels-position-save", {
            path: outputPath
          }));
        } else {
          toast.error(t("toast.labels-export-failed"));
        }
        if (extractPoints) {
          if (!successCombine && (visibleClouds.length > 1)) {
            toast.error(t("toast.labels-combine-failed"));
          }
          else if (!successConvert && convertAttempted) {
            toast.error(t("toast.labels-convert-failed"));
          }
          else if (!successLabelInPC) {
            toast.error(t("toast.labels-find-points-failed"));
          }
          else if (!successLasWritten) {
            toast.error(t("toast.labels-write-failed"));
          }
          else {
            toast.success(t("toast.labels-las-written-save", {
              path: lasOutputPath
            }));
            await addPointCloudFiles([lasOutputPath], defaultFolder.id);
            if (overwrite && (visibleClouds.length === 1)){
              dispatch(deleteAsset(visibleClouds[0].id));
            }
          }
        }

        resetExecutableValues();
      }
    });
  };

  const resetDefaultValues = () => {
    // Shared parameters
    setImageSamplingDistance(defaults.image_sampling_dist);
    setExtractPoints(false);

    // Point synthesis parameters
    setIntersectionAngle(defaults.intersection_angle);
    setMinNumMatches(defaults.min_num_matches);
    setPositionConfidence(defaults.position_confidence);
    setMaxDistanceFromCamera(defaults.max_distance_from_camera);
    setCloseLabelDist(defaults.close_label_dist);

    // Ray intersection parameters
    setMinCameraDistance(defaults.min_camera_distance);
    setMaxCameraDistance(defaults.max_camera_distance);
    setMaxIntersectDistance(defaults.max_intersect_distance);
    setClusterDistance(defaults.cluster_distance);
    setNumMatchesRequired(defaults.num_matches_required);

    // Point Extraction Parameters
    setOverwrite(false);
    setObjSize(defaults.object_size);

  };

  useEffect(() => {
    getCategoryClasses(categories);
    getIgnoreClasses();
    if (open) {
      return;
    }
    resetDefaultValues();
    setOutputPath(null);
  }, [open]);

  useEffect(() => {
    resetDefaultValues();
  }, [method]);

  const useFunctionV1 = method === "label_intersect";
  const useFunctionV2 = method === "label_intersect_v2";
  const folderSelected = outputPath !== null;

  let canSubmit = folderSelected
    && !imageSamplingDistance.error
    && !intersectionAngle.error
    && !minNumMatches.error
    && !positionConfidence.error
    && !maxDistanceFromCamera.error
    && !closeLabelDist.error
    && !minCameraDistance.error
    && !maxCameraDistance.error
    && !maxIntersectDistance.error
    && !clusterDistance.error
    && !numMatchesRequired.error;

  return (
    <React.Fragment>
      {/* Label Analysis Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth={"sm"}
      >
        <DialogTitle>{t('labels.label-analysis')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>

            {/* Export method */}
            <Grid item xs={cloudsAvailable? 4 : 6}>
              <DropdownWithLabel
                title={t('labels.position-estimation-method')}
                label={t('labels.determines-which-method-will-be-used-when')}
                value={method}
                onChange={setMethod}
                options={[
                  ["label_intersect", t('labels.point-synthesization')],
                  ["label_intersect_v2", t('labels.ray-intersection')]
                ]}
              />
            </Grid>

            {/* Output folder */}
            <Grid item xs={cloudsAvailable? 4 : 6}>
              <FolderWithLabel
                title={t('labels.output-folder')}
                label={t('labels.the-output-folder-where-generated-csvs-will-be-created')}
                value={outputPath}
                onChange={setOutputPath}
              />
            </Grid>
            {(useFunctionV2 && cloudsAvailable) && (<Grid item xs={4}>
              <CheckboxWithLabel
                title={t('labels.extract-points')}
                label={t('labels.extract-points-in-labels')}
                value={extractPoints}
                onChange={setExtractPoints}
              />
            </Grid>)}

          </Grid>

          <DenseDivider variant="middle" spacing={20}/>

          <Grid container spacing={2}>
            <Grid item xs={10}>
              <DialogTitle>{t('labels.position-parameters')}</DialogTitle>
            </Grid>
            <Grid item xs={2}>
              <CategoryExpand
                setExpanded={setCollapse1}
                expanded={collapse1}
              />
            </Grid>
          </Grid>
          <DenseDivider variant="middle" spacing={[5, 20]}/>

          {/* Function parameters for V1 of function */}
          {(useFunctionV1 && collapse1) && (<Grid container spacing={2}>

            {/* Minimum intersect angle */}
            <Grid item xs={6}>
              <NumberFieldWithLabel
                title={t('labels.intersection-angle')}
                label={t('labels.the-minimum-allowed-angle-of-intersection')}
                data={intersectionAngle}
                setData={setIntersectionAngle}
                min={0}
                max={30}
                step={0.1}
              />
            </Grid>

            {/* Number of matches */}
            <Grid item xs={6}>
              <NumberFieldWithLabel
                title={t('labels.minimum-number-of-matches')}
                label={t('labels.the-minimum-number-of-matching-label')}
                data={minNumMatches}
                setData={setMinNumMatches}
                min={1}
                max={50}
              />
            </Grid>

            {/* Position confidence */}
            <Grid item xs={6}>
              <DropdownWithLabel
                title={t('labels.position-confidence')}
                label={t('labels.confidence-of-output-position')}
                value={positionConfidence.value}
                onChange={(value: string) => {
                  setPositionConfidence({
                    value: value,
                    error: false
                  });
                }}
                options={[
                  ["low", t('general.low')],
                  ["medium", t('general.medium')],
                  ["high", t('general.high')]
                ]}
              />
            </Grid>

            {/* Max camera distance */}
            <Grid item xs={6}>
              <NumberFieldWithLabel
                title={t('labels.max-distance-from-camera')}
                label={t('labels.approximate-maximum-distance')}
                data={maxDistanceFromCamera}
                setData={setMaxDistanceFromCamera}
                min={1}
                max={100}
                units
              />
            </Grid>

            {/* Image sampling distance */}
            <Grid item xs={6}>
              <NumberFieldWithLabel
                title={t('labels.image-sampling-distance')}
                label={t('labels.minimum-distance-between-images')}
                data={imageSamplingDistance}
                setData={setImageSamplingDistance}
                min={0.2}
                max={5}
                step={0.1}
                units
              />
            </Grid>

            {/* Clustering distance */}
            <Grid item xs={6}>
              <NumberFieldWithLabel
                title={t('labels.duplicate-label-threshold')}
                label={t('labels.while-estimating-label-positions-combine')}
                data={closeLabelDist}
                setData={setCloseLabelDist}
                min={0.2}
                max={5}
                step={0.1}
                units
              />
            </Grid>
          </Grid>)}

          {/* Function parameters for V2 of function */}
          {(useFunctionV2 && collapse1) && (<Grid container spacing={2}>

            {/* Intersect Distance */}
            <Grid item xs={6}>
              <NumberFieldWithLabel
                title={t('labels.max-intersection-distance')}
                label={t('labels.the-maximum-allowed-distance-between-calculated-rays')}
                data={maxIntersectDistance}
                setData={setMaxIntersectDistance}
                min={0.2}
                max={5}
                step={0.1}
                units
              />
            </Grid>

            {/* Number of matches required */}
            <Grid item xs={6}>
              <NumberFieldWithLabel
                title={t('labels.number-of-required-matches')}
                label={t('labels.the-number-of-label-considered')}
                data={numMatchesRequired}
                setData={setNumMatchesRequired}
                min={2}
                max={5}
              />
            </Grid>

            {/* Min camera distance */}
            <Grid item xs={6}>
              <NumberFieldWithLabel
                title={t('labels.min-distance-from-camera')}
                label={t('labels.approximate-minimum-distance')}
                data={minCameraDistance}
                setData={setMinCameraDistance}
                min={0}
                max={20}
                step={0.5}
                units
              />
            </Grid>

            {/* Max camera distance */}
            <Grid item xs={6}>
              <NumberFieldWithLabel
                title={t('labels.max-distance-from-camera')}
                label={t('labels.approximate-maximum-distance')}
                data={maxCameraDistance}
                setData={setMaxCameraDistance}
                min={1}
                max={100}
                units
              />
            </Grid>

            {/* Image sampling distance */}
            <Grid item xs={6}>
              <NumberFieldWithLabel
                title={t('labels.image-sampling-distance')}
                label={t('labels.minimum-distance-between-images')}
                data={imageSamplingDistance}
                setData={setImageSamplingDistance}
                min={0.2}
                max={5}
                step={0.1}
                units
              />
            </Grid>

            {/* Clustering distance */}
            <Grid item xs={6}>
              <NumberFieldWithLabel
                title={t('labels.duplicate-label-threshold')}
                label={t('labels.while-estimating-label-positions')}
                data={clusterDistance}
                setData={setClusterDistance}
                min={0.2}
                max={5}
                step={0.1}
                units
              />
            </Grid>
            <DenseDivider variant="middle" spacing={20}/>
          </Grid>)}

          {(extractPoints) && (<React.Fragment>
            <Grid container spacing={2}>
              <Grid item xs={10}>
                <DialogTitle>{t('labels.point-extraction-parameters')}</DialogTitle>
              </Grid>
              <Grid item xs={2}>
                <CategoryExpand
                  setExpanded={setCollapse2}
                  expanded={collapse2}
                />
              </Grid>
            </Grid>
            <DenseDivider variant="middle" spacing={[5, 20]}/>
            {(collapse2) && (<React.Fragment>
              <TextWithLabel
                title={t('labels.las-classes-per-label-cat')}
                label={t('labels.classes-lower-in-the-list-will-be-applied')}
              />
              <Grid container direction="column" spacing={2}>
                <Paper className={classes.flexPaper}>
                  <DraggableList
                    items={categoryClasses}
                    onDragEnd={onDragEnd}
                    setData={updateCategoryNumbers}
                    inputName={t('labels.las-classification')}
                  />
                </Paper>
              </Grid>
              <Grid container  spacing={2} className={classes.box}>
                {/* Object Size */}
                <Grid item xs={6}>
                  <NumberFieldWithLabel
                    title={t("labels.extract-points-object-size")}
                    label={t("labels.extract-point-obj-size-label")}
                    data={objSize}
                    setData={setObjSize}
                    min={0.5}
                    max={50}
                    step={0.5}
                    units
                  />
                </Grid>
                {/* Overwrite Las */}
                <Grid item xs={6}>
                  <InputLabel>{t("labels.extract-points-overwrite")}</InputLabel>
                  <Typography variant="caption">
                    {t("labels.extract-points-overwrite-info")}
                  </Typography>
                  <Checkbox
                    checked={overwrite}
                    onChange={(event) => {
                      setOverwrite(event.target.checked);
                    }}
                    size="small"
                    color="secondary"
                  />
                </Grid>
              </Grid>
              <TextWithLabel
                title={t("labels.extract-points-ignore-classes")}
                label={t("labels.extract-points-ignore-classes-info")}
              />
              <Grid container spacing={2} alignItems={'flex-end'} className={classes.box}>
                {ignoreClasses.map((ignoreClass, index) => (
                  <Grid item xs={3} key={index.toString()}>
                    <InputLabel>
                      {ignoreClass.name}
                    </InputLabel>
                    <Checkbox
                      checked={ignoreClass.value}
                      onChange={(event) => {
                        updateIgnoreClasses(index, event.target.checked);
                      }}
                      size="small"
                      color="secondary"
                    />
                    <Typography variant="caption">
                      {`${ignoreClass.classification}`}
                    </Typography>
                  </Grid>
                ))}
              </Grid>


            </React.Fragment>)}
          </React.Fragment>)}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('buttons.cancel')}
          </Button>

          <Button onClick={handleSubmit} disabled={!canSubmit} color="primary">
            {t('buttons.submit')}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

const ImportDialog = (props) => {
  const classes = useStyles();
  const {t} = useTranslation();
  const {viewer} = useViewer();
  const theme = useTheme();

  const tableState = useTableState();

  const [disabled, setDisabled] = useState(false);
  const [importCategory, setImportCategory] = useState({});
  const [overwrite, setOverwrite] = useState(true);
  const [importLarge, setImportLarge] = useState(false);
  const [importPoints, setImportPoints] = useState(true);
  const [importLines, setImportLines] = useState(true);
  const [checkOverlap, setCheckOverlap] = useState(false);

  const [lineBuffer, setLineBuffer] = useState("0.5"); // TODO: pull from global setting later?
  const [pointBuffer, setPointBuffer] = useState("0.5"); // TODO: pull from global setting later?

  const {importData, setImportData, isOrthoLabel,
    categoryList, setLabelLoadProgress} = props;

  const open = !!importData;

  const categories = importData
    ? importData.categories as any[]
    : [];

  let annotations = importData
    ? importData.annotations as any[]
    : [];

  const hasLines = annotations.filter(x => x.is_linestring).length > 0;
  const hasPoints = annotations.filter(x => x.is_point).length > 0;

  let hasLargeClasses = false;
  categories.forEach(category => {
    let numGeometry = annotations
      .filter(x => x.category_id === category.id)
      .length;
    if (numGeometry > geometryLimit) {
      hasLargeClasses = true;
    }
  });

  const columns = [
    {
      id: 'name',
      label: t('labels.class-name')
    },
    {
      id: 'count',
      label: t('labels.geometry-count'),
      numeric: true
    },
    {
      id: 'category',
      label: t('labels.imported-class-name')
    },
  ];

  const categoryNames = Array.from(new Set([
    ...categoryList.map(x => x.name),
    ...categories.map(x => x.name)
  ])).sort((a, b) => a.localeCompare(b));

  const filterAnnotationTypes = (data) => {
    return [...data].filter(x => {
      if (!importPoints && x.is_point) {
        return false;
      } else if (!importLines && x.is_linestring) {
        return false;
      }

      return true;
    });
  };

  const validBufferSize = (buffer) => {
    let bufferSize = parseFloat(buffer);
    let minIterations = 0.01;
    let maxIterations = 10;

    let validNumber = (bufferSize >= minIterations)
      && (bufferSize <= maxIterations);

    if (!validNumber) {
      toast.error(t("toast.labels-buffer-size", {
        minIterations,
        maxIterations
      }));
      return false;
    }

    return true;
  };

  const handleClose = () => {
    setImportData(null);
  };

  const handleImport = async () => {
    if ((hasPoints && importPoints) && !validBufferSize(pointBuffer)) {
      return;
    }

    if ((hasLines && importLines) && !validBufferSize(lineBuffer)) {
      return;
    }

    const labelData = {
      ...importData,
      annotations: filterAnnotationTypes(importData.annotations)
    };

    const importCategories = [];

    labelData.categories.forEach((category, index) => {
      let newCategoryName = getMappedCategory(category.name);

      let numGeometry = labelData.annotations
        .filter(x => x.category_id === category.id)
        .length;

      if (numGeometry === 0) {
        return;
      }

      let ignoreLayer = (newCategoryName === LabelImportType.Ignore)
        || (importLarge ? false : numGeometry > geometryLimit);

      if (ignoreLayer) {
        // Filter our data for this category
        labelData.annotations = labelData.annotations
          .filter(x => x.category_id !== category.id);

        return;
      }

      importCategories.push({
        ...category,
        name: newCategoryName
      });
    });

    // Apply linestring / point buffer
    labelData.annotations.forEach((anno, index) => {
      if (anno.is_linestring) {
        labelData.annotations[index].buffer_size = lineBuffer;
      } else if (anno.is_point) {
        labelData.annotations[index].buffer_size = pointBuffer;
      }
    });

    // Replace categories with remapped version
    labelData.categories = importCategories;

    handleClose();

    // Nothing left, exit early
    if (labelData.categories.length === 0) {
      toast.warning(t("toast.labels-not-available"));
    } else {
      await viewer?.loadImageLabelData(
        labelData,
        setLabelLoadProgress,
        overwrite,
        checkOverlap
      );

      toast.success(t("toast.labels-load-success"));
    }
  };

  const getMappedCategory = (key) => {
    return importCategory[key]
      ? importCategory[key]
      : key;
  };

  const createSelect = (key, disabled) => {
    return (
      <Select
        disabled={disabled}
        disableUnderline
        value={getMappedCategory(key)}
        className={classes.tableDropdown}
        onChange={(event) => {
          const updated = {...importCategory};
          updated[key] = event.target.value;
          setImportCategory(updated);
        }}
      >
        {getLayerMenuItems()}
      </Select>
    );
  };

  const getLayerMenuItems = () => {
    const menuIgnore = (
      <MenuItem
        key={nanoid()}
        value={LabelImportType.Ignore}
      >
        {t('labels.ignore-layer')}
      </MenuItem>
    );

    const menuDivider = (
      <hr key={nanoid()} className={classes.selectDivider}/>
    );

    return [
      menuIgnore,
      menuDivider,
      ...categoryNames.map(name => (
        <MenuItem
          key={nanoid()}
          value={name}
        >
          {name}
        </MenuItem>
      ))
    ];
  };

  const onMenuClick = (event) => {
    const value = event.target.value;
    const updated = {...importCategory};
    categories.forEach(data => {
      if (value === LabelImportType.Default) {
        delete updated[data.name];
      } else {
        updated[data.name] = value;
      }
    });

    setImportCategory(updated);
  };

  const getRows = () => {
    const filtered = categories.filter(category => {
      let numGeometry = annotations
        .filter(x => x.category_id === category.id)
        .length;
      return numGeometry > 0;
    });

    return filtered.map((category, index) => {
      let numGeometry = annotations
        .filter(x => x.category_id === category.id)
        .length;

      let disabled = !importLarge && (numGeometry > geometryLimit);

      return {
        id: `ImportLayerTableRow_${index}`,
        name: category.name as string,
        count: numGeometry,
        category: createSelect(category.name, disabled),
        disabled
      };
    });
  };

  const handlePointBufferChange = (event) => {
    setPointBuffer(event.target.value);
  };

  const handleLineBufferChange = (event) => {
    setLineBuffer(event.target.value);
  };

  useEffect(() => {
    if (!importData) {
      setImportCategory({});
      setOverwrite(true);
      setCheckOverlap(false);
      setImportLarge(false);
      setImportPoints(true);
      setImportLines(true);
    }
  }, [importData]);

  useEffect(() => {
    let valid = true;

    if (importLines && lineBuffer === "") {
      valid = false;
    }

    if (importPoints && pointBuffer === "") {
      valid = false;
    }

    setDisabled(!valid);
  }, [importLines, importPoints, pointBuffer, lineBuffer]);

  annotations = filterAnnotationTypes(annotations);

  const rows = getRows();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      scroll="body"
      maxWidth={"sm"}
    >
      <DialogTitle>{t('labels.import-labels')}</DialogTitle>

      <Grid container spacing={0} className={classes.checkBoxParent}>

        {/* Setting layer default */}
        <Grid item xs={8}>
          <div className={clsx(classes.checkBoxWithLabel, classes.mappingMargin)}>
            <InputLabel>{t('labels.apply-class-mapping')}</InputLabel>

            <Select
              disableUnderline
              value={"__empty"}
              onChange={onMenuClick}
            >
              <MenuItem disabled value="__empty">{t('labels.select-option')}</MenuItem>
              <MenuItem value={LabelImportType.Default}>{t('labels.default-mapping')}</MenuItem>
              {getLayerMenuItems()}
            </Select>
          </div>
        </Grid>

        {/* Overwrite existing labels */}
        <Grid item xs={8}>
          <div className={classes.checkBoxWithLabel}>
            <InputLabel>{t('labels.overwrite-existing-labels')}</InputLabel>

            <Checkbox
              checked={overwrite}
              onChange={(event) => {
                setOverwrite(event.target.checked);
              }}
              size="small"
              color="secondary"
            />
          </div>
        </Grid>

        {/* Ignore outside image bounds */}
        {isOrthoLabel && (<Grid item xs={8}>
          <div className={classes.checkBoxWithLabel}>
            <InputLabel>{t('labels.discard-non-overlapping-labels')}</InputLabel>

            <ArrowTooltip title={t('labels.discard-labels-that-do-not-intersect')}>
              <Checkbox
                checked={checkOverlap}
                onChange={(event) => {
                  setCheckOverlap(event.target.checked);
                }}
                size="small"
                color="secondary"
              />
            </ArrowTooltip>
          </div>
        </Grid>)}

        {/* Import large classes */}
        {hasLargeClasses && (<Grid item xs={8}>
          <div className={classes.checkBoxWithLabel}>
            <InputLabel>
              {t('labels.import-large-classes')}
            </InputLabel>

            <ArrowTooltip title={t('labels.import-classes-with-limit-geometry-count', {
              count: geometryLimit
            })}>
              <Checkbox
                checked={importLarge}
                onChange={(event) => {
                  setImportLarge(event.target.checked);
                }}
                size="small"
                color="secondary"
              />
            </ArrowTooltip>
          </div>
        </Grid>)}

        {/* Import polylines */}
        <Grid item xs={8}>
          {hasLines && (<div className={classes.checkBoxWithLabel}>
            <InputLabel>{t('labels.import-linestrings')}</InputLabel>

            <Checkbox
              checked={importLines}
              onChange={(event) => {
                setImportLines(event.target.checked);
              }}
              size="small"
              color="secondary"
            />
          </div>)}
          {(hasLines && importLines) && (<Typography variant="caption">
            {t('labels.a-buffer-will-be-applied-to-convert-to-a-polygon')}
          </Typography>)}
        </Grid>

        <Grid item xs={4}>
          {(hasLines && importLines) && (<div>
            <TextField
              margin="dense"
              type="number"
              fullWidth
              onChange={handleLineBufferChange}
              InputLabelProps={{ shrink: true }}
              label={t('labels.line-buffer-units', {
                units: LocalScene.dataProjectionUnits
              })}
              value={lineBuffer}
            />
          </div>)}
        </Grid>

        {/* Import points */}
        <Grid item xs={8}>
          {hasPoints && (<div className={classes.checkBoxWithLabel}>
            <InputLabel>{t('labels.import-points')}</InputLabel>

            <Checkbox
              checked={importPoints}
              onChange={(event) => {
                setImportPoints(event.target.checked);
              }}
              size="small"
              color="secondary"
            />
          </div>)}
          {(hasPoints && importPoints) && (<Typography variant="caption">
            {t('labels.a-buffer-will-be-applied-to-convert-to-a-polygon')}
          </Typography>)}
        </Grid>

        <Grid item xs={4}>
          {(hasPoints && importPoints) && (<div>
            <TextField
              margin="dense"
              type="number"
              fullWidth
              onChange={handlePointBufferChange}
              InputLabelProps={{ shrink: true }}
              label={t('labels.point-buffer-units', {
                units: LocalScene.dataProjectionUnits
              })}
              value={pointBuffer}
            />
          </div>)}
        </Grid>

      </Grid>

      <DialogContent style={{
        paddingTop: theme.spacing(2)
      }}>
        <EnhancedTable
          state={tableState}
          columns={columns}
          rows={rows}
          maxHeight={"300px"}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>
          {t('buttons.cancel')}
        </Button>

        <Button onClick={handleImport} disabled={disabled}>
          {t('buttons.import-data')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const ClassifyFromAerial = (props) => {
  const {categories, open, setOpen, setProgress,
    pointClouds} = props;

  const classes = useStyles();
  const dispatch = useDispatch();
  const {viewer} = useViewer();
  const {t} = useTranslation();

  const [rows, setRows] = useState([]);
  const [sorted, setSorted] = useState(false);
  const [sortedAlpha, setSortedAlpha] = useState(false);
  const [sortByNum, setSortByNum] = useState(false);
  const [overwriteFile, setOverwriteFile] = useState(false);
  const [preserveGround, setPreserveGround] = useState(false);
  const [newLasPath, setNewLasPath] = useState(null);

  const LASfiles = pointClouds.filter(x => x.type === AssetType.LAS);

  const minLasVersion = Math.min(...LASfiles.map(pointCloud => {
    const header = viewer.getLasFileInfo(pointCloud.id);
    return header ? parseFloat(header.attributes.version) : 0;
  }));

  const visibleClouds = LASfiles.filter(x => x.visible);
  const mixedData = (LASfiles.length !== pointClouds.length);
  const maxNumClasses = (minLasVersion >= 1.4) ? 255 : 31;

  const canSubmit = (visibleClouds.length > 0)
    && (minLasVersion > 0)
    && ((newLasPath !== null) || (overwriteFile))
    && rows.filter(x => x.error).length === 0;

  const checkNamesForClass = (name) => {
    let classNum = getClassFromAlias(name);
    if (classNum < 0) {
      classNum = 0;
    }
    return classNum;
  };

  const getRows = (categories) => {
    let rowsTemp = categories.map((category, index) => {
      let name = category.name;
      let lasClass = checkNamesForClass(name);

      return {
        id: `AerialClassifyTableRow_${index}`,
        index: index,
        primary: name,
        secondary: lasClass,
        error: false,
        min: 0,
        max: maxNumClasses,
        step:1,
      };
    });

    setRows([...rowsTemp]);
  };

  const updateClassNumbers = (data) => {
    let rowsTemp = [...rows];
    rowsTemp[data.index].secondary = data.value;
    rowsTemp[data.index].error = data.error;
    setRows([...rowsTemp]);
  };

  const handleClose = () => {
    setOpen(false);
    setProgress(0);
    setOverwriteFile(false);
    setPreserveGround(false);
  };

  const handleSubmit = () => {
    setOpen(false);
    classifyPointclouds();
  };

  const classifyPointclouds = () => {
    const applicationOrder = rows.map(row => row.primary);
    const lasClasses = rows.map(row => parseInt(row.secondary));
    const inputPaths = visibleClouds.map(x => x.path);
    const overwriteGround = !preserveGround;
    const outputPath = newLasPath;

    const polygonData = viewer.getOrthoLabelPolygons();
    const jsonData = applicationOrder.map((name, index) => {
      return {
        name,
        class: lasClasses[index],
        segments: polygonData[name]
      };
    });

    const text = JSON.stringify(jsonData, null, 4);
    const tempTextPath = getTemporaryFile("txt");

    try {
      fs.writeFileSync(tempTextPath, text);
    } catch(err) {
      console.log(err);
      toast.error(t("toast.labels-aerial-error"));
      return;
    }

    toast.success(t('toast.aerial_classification_submitted'));

    let newCloudPaths = null;
    let processTimeout = 500;

    let exe = new PythonExecutable();
    let commands = [
      "-p", "classify_from_aerial",
      "--input_paths", inputPaths,
      "--input_json", tempTextPath,
      "--overwrite_ground", overwriteGround,
      "--overwrite_file", overwriteFile
    ];

    if (!overwriteFile) {
      commands.push("--output_folder");
      commands.push(outputPath);
    }

    exe.run({
      command: commands,
      saveLogs: true,
      onLine: jsonData => {
        if (jsonData.label_bounds_error) {
          toast.error(t("toast.labels-aerial-error-bounds"));
        } else if (jsonData.progress) {
          setProgress(jsonData.progress);
        } else if (jsonData.overwrite_failure) {
          toast.error(t("toast.labels-aerial-error-overwrite"));
        } else if (jsonData.output_paths) {
          newCloudPaths = jsonData.output_paths;
        }
      },
      onClose: async () => {
        if (!newCloudPaths) {
          toast.warning(t("toast.labels-classify-incomplete"));
          handleClose();
          return;
        }

        await asyncTimeout(processTimeout);
        toast.success(t("toast.labels-import-modified"));

        visibleClouds.forEach((asset, index) => {
          const assetPath = newCloudPaths[index];

          // Add new pointcloud
          dispatch(addAsset({
            folderID: asset.folderID,
            name: path.basename(assetPath),
            path: assetPath,
            type: asset.type
          }));

          // Remove old pointcloud
          dispatch(deleteAsset(asset.id));
        });

        handleClose();
      }
    });
  };

  const sortRowsByClassNum = (reverseSort) => {
    let rowsTemp = [...rows];
    if (rows.length === 0) {
      return;
    }

    if (!reverseSort){
      rowsTemp.sort((a,b) => a.secondary - b.secondary);
    }
    else {
      rowsTemp.sort((a,b) => b.secondary - a.secondary);
    }

    rowsTemp.forEach((row, index) => row.index=index);
    setRows([...rowsTemp]);
    setSortByNum(!reverseSort);
    setSorted(true);
  };

  const sortRowsAlphabetically = () => {
    let rowsTemp = [...rows];
    if (rows.length === 0) {
      return;
    }

    rowsTemp.sort((a, b) => a.primary.localeCompare(b.primary));
    rowsTemp.forEach((row, index) => row.index=index);
    setSortedAlpha(true);
    setRows([...rowsTemp]);
  };

  const sortReset = () => {
    let rowsTemp = [...rows];
    if (rows.length === 0) {
      return;
    }

    rowsTemp.sort((a,b) => parseInt(a.id) - parseInt(b.id));
    rowsTemp.forEach((row, index) => row.index=index);
    setSorted(false);
    setSortedAlpha(false);
    setRows([...rowsTemp]);
  };

  const onDragEnd = ({ destination, source }: DropResult) => {
    if (!destination) return;

    let rowsTemp = [...rows];
    const [removed] = rowsTemp.splice(source.index, 1);
    rowsTemp.splice(destination.index, 0, removed);
    rowsTemp.forEach((row, index) => row.index=index);

    setRows([...rowsTemp]);
    return;
  };

  useEffect(() => {
    getRows(categories);
  }, [open]);

  const sortButtonTitle = sorted
    ? t('labels.reverse-sort-order')
    : t('labels.sort-by-las-classification');

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle>{t('labels.classify-point-cloud-from-aerial-image')}</DialogTitle>
      <DialogContent className={classes.captionPadding}>
        <Typography variant="caption">
          {t('labels.classes-lower-in-the-list-will-be-applied')}
        </Typography>

        <div className={classes.paddingBottomAndTopMinimal}>
          <EnhancedIconButton
            title={sortButtonTitle}
            onClick={() => {
              sortRowsByClassNum(sortByNum);
            }}
          >
            <ImportExportIcon fontSize="small"/>
          </EnhancedIconButton>

          <EnhancedIconButton
            title={t('labels.sort-by-class-name')}
            onClick={() => {
              sortRowsAlphabetically();
            }}
          >
            <SortByAlphaIcon fontSize="small"/>
          </EnhancedIconButton>


          {(sorted || sortedAlpha) && <EnhancedIconButton
            title={t('labels.reset-to-original-order')}
            onClick={() => {
              sortReset();
            }}
          >
            <HistoryIcon fontSize="small"/>
          </EnhancedIconButton>}
        </div>

        <Paper className={classes.flexPaper}>
          <DraggableList
            items={rows}
            onDragEnd={onDragEnd}
            setData={updateClassNumbers}
            inputName={t('labels.las-classification')}
          />
        </Paper>

        <Grid container spacing={2}>

          {/* Preserve ground classification */}
          <Grid item xs={12}>
            <CheckboxWithLabel
              title={t('labels.preserve-ground')}
              label={t('labels.points-in-point-cloud-pre-classified')}
              value={preserveGround}
              onChange={setPreserveGround}
            />
          </Grid>

          {/* Overwrite point clouds */}
          <Grid item xs={12}>
            <CheckboxWithLabel
              title={t('labels.overwrite-existing-las-files')}
              label={t('labels.las-files-will-be-overwritten')}
              value={overwriteFile}
              onChange={setOverwriteFile}
            />
          </Grid>

          {/* Output folder */}
          {!overwriteFile && <Grid item xs={12}>
            <FolderWithLabel
              title={t('labels.point-cloud-path')}
              label={t('labels.output-las-file-destination-of-new-classified-files')}
              value={newLasPath}
              onChange={setNewLasPath}
            />
          </Grid>}

        </Grid>

        {mixedData && (<Box className={classes.mixedDataWarning}>
          <Typography variant="caption" align="center">
            {t('labels.classification-from-aerial-will-only-apply-to-las-files')}
          </Typography>
        </Box>)}

      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t('buttons.cancel')}
        </Button>

        <Button onClick={handleSubmit} color="primary" disabled={!canSubmit}>
          {t('buttons.submit')}
        </Button>
      </DialogActions>

    </Dialog>
  );
};

const ClassificationParameters = (props) => {
  const {open, setOpen, runClassification, defaultScore} = props;

  const classes = useStyles();
  const {t} = useTranslation();

  const [modelPath, setModelPath] = useState(null);
  const [runOnCPU, setRunOnCPU] = useState(false);
  const [score, setScore] = useState({
    value: defaultScore,
    error: false
  });

  const handleCancel = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    toast.success(t("toast.labels-classify-submit"));
    runClassification(parseFloat(score.value), modelPath, runOnCPU);
    setOpen(false);
  };

  const resetDefaults = () => {
    setModelPath(null);
    setRunOnCPU(false);
    setScore({value: defaultScore, error: false});
  };

  useEffect(() => {
    if (open) return;
    resetDefaults();
  }, [open]);

  const canSubmit = (modelPath !== null) && (!score.error);

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={open}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle>{t('labels.model-classification-parameters')}</DialogTitle>

      <DialogContent>

        {/* Classification Score */}
        <InputLabel>{t('labels.classification-score')}</InputLabel>
        <NumberField
          className={classes.paddingBottom}
          data={score}
          setData={setScore}
          min={0.1}
          max={1.0}
          step={0.1}
        />

        {/* Model path */}
        <div className={classes.paddingBottom}>
          <FileWithLabel
            title={t('labels.model-file')}
            label={t('labels.trained-model-file-that-is-used')}
            filter={modelFilter}
            value={modelPath}
            onChange={setModelPath}
          />
        </div>

        {/* Run on CPU */}
        <div className={classes.checkBoxWithLabel}>
          <InputLabel>{t('labels.run-on-cpu')}</InputLabel>
          <Checkbox
            checked={runOnCPU}
            onChange={(event) => {
              setRunOnCPU(event.target.checked);
            }}
            size="small"
            color="secondary"
          />
        </div>

        <Typography variant="caption" className={classes.paddingBottom}>
          {t('labels.running-on-cpu-is-slower')}
        </Typography>

      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          {t('buttons.cancel')}
        </Button>

        <Button onClick={handleSubmit} color="primary" disabled={!canSubmit}>
          {t('buttons.submit')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const TrainingParameters = (props) => {
  const {open, setOpen, runTraining, defaultIterations} = props;
  const {t} = useTranslation();

  const [outputPath, setOutputPath] = useState(null);
  const [pretrainedPath, setPretrainedPath] = useState(null);
  const [runOnCPU, setRunOnCPU] = useState(false);
  const [iterations, setIterations] = useState({
    value: defaultIterations,
    error: false,
  });

  const handleCancel = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    runTraining(parseInt(iterations.value), outputPath, pretrainedPath, runOnCPU);
    setOpen(false);
  };

  const resetDefaults = () => {
    setPretrainedPath(null);
    setRunOnCPU(false);
    setOutputPath(null);
    setIterations({value: defaultIterations, error: false});
  };

  useEffect(() => {
    if (open) return;
    resetDefaults();
  }, [open]);

  const canSubmit = (outputPath !== null) && (!iterations.error);

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={open}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle>{t('labels.model-training-parameters')}</DialogTitle>

      <DialogContent>
        <Grid container spacing={2}>

          {/* Training iterations */}
          <Grid item xs={12}>
            <NumberFieldWithLabel
              title={t('labels.training-iterations')}
              data={iterations}
              setData={setIterations}
              min={10}
              max={8192}
            />
          </Grid>

          {/* Output folder */}
          <Grid item xs={12}>
            <FolderWithLabel
              title={t('labels.model-output-folder')}
              label={t('labels.the-output-folder-where-the-new-model-will-be-created')}
              value={outputPath}
              onChange={setOutputPath}
            />
          </Grid>

          {/* Run on CPU */}
          <Grid item xs={12}>
            <CheckboxWithLabel
              title={t('labels.run-on-cpu')}
              label={t('labels.running-on-cpu-is-slower')}
              value={runOnCPU}
              onChange={setRunOnCPU}
            />
          </Grid>

          <Grid item xs={12}>
            {/* Pretrained model */}
            <FileWithLabel
              title={t('labels.pretrained-model-path-optional')}
              label={t('labels.if-a-previously-trained-model-is-selected')}
              filter={modelFilter}
              value={pretrainedPath}
              onChange={setPretrainedPath}
              optional
            />
          </Grid>

        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          {t('buttons.cancel')}
        </Button>

        <Button onClick={handleSubmit} color="primary" disabled={!canSubmit}>
          {t('buttons.submit')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const GetInfoWindow = (props) => {
  const {open, setOpen, label, index, isSceneLabel} = props;

  const classes = useStyles();
  const {viewer} = useViewer();
  const {t} = useTranslation();

  const orignalText = label.text.split('\n');
  const [text, setText] = useState(orignalText);

  const scoreClass = (score) => {
    let scoreValidity = classes.success;
    if (score < 0.9) {
      scoreValidity = classes.warning;
    }
    if (score < 0.7) {
      scoreValidity = classes.error;
    }
    return scoreValidity;
  };

  const handleCancel = () => {
    setText([...orignalText]);
    setOpen(false);
  };

  const updateLabelText = (txtList) => {
    const newText = txtList.join("\n");
    viewer?.setLabelText(label.id, newText);
  };

  const handleSubmit = () => {
    let trimmedText = text.map(x => x.trim());
    setText([...trimmedText]);
    updateLabelText(trimmedText);
    setOpen(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  const handleTextChange = (event, index) => {
    let newText = [...text];
    newText[index] = event.target.value;
    setText([...newText]);
  };

  const classValid = label.valid
    ? classes.success
    : classes.error;

  const classHighlight = label.highlighted
    ? classes.success
    : classes.error;

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={open}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle>{t('labels.label-info')}</DialogTitle>

      <DialogContent>
        <InputLabel>{t('labels.information')}</InputLabel>
        <List>

          {/** Label Number */}
          <ListItem>
            <Typography variant="caption" className={classes.infoLabel}>
              {t('labels.label-number', {index})}
            </Typography>
          </ListItem>

          {/** Valid Geometry */}
          <ListItem>
            <Typography variant="caption" className={classes.infoLabel}>
              {`${t('labels.polygon-valid')}:`}
            </Typography>
            <Typography variant="caption" className={classValid}>
              {String(label.valid).toUpperCase()}
            </Typography>
          </ListItem>

          {/** Highlighted */}
          <ListItem>
            <Typography variant="caption" className={classes.infoLabel}>
              {`${t('labels.highlighted')}:`}
            </Typography>
            <Typography variant="caption" className={classHighlight}>
              {String(label.highlighted).toUpperCase()}
            </Typography>
          </ListItem>

          {/** Classification Score */}
          <ListItem>
            <Typography variant="caption" className={classes.infoLabel}>
              {`${t('labels.classification-score')}:`}
            </Typography>
            <Typography variant="caption" className={scoreClass(label.score)}>
              {label.score.toFixed(2)}
            </Typography>
          </ListItem>

          {(isSceneLabel) && <React.Fragment>
            {/** Text Confidence */}
            <ListItem>
              <Typography variant="caption" className={classes.infoLabel}>
                {`${t('labels.text-detection-score')}:`}
              </Typography>
              <Typography variant="caption" className={scoreClass(label.textScore)}>
                {`${label.textScore.toFixed(2)}`}
              </Typography>
            </ListItem>

            {/** Detected Text */}
            <ListItem>
              <List>
                {text.map((txt, index)=>
                  <TextField
                    key={index}
                    onChange={(event) => handleTextChange(event, index)}
                    onKeyDown={(event) => handleKeyDown(event)}
                    autoFocus
                    margin="dense"
                    size="small"
                    label={t('labels.detected-text-line-line', {
                      line: index+1
                    })}
                    type="text"
                    fullWidth
                    value={txt}
                  />
                )}
              </List>
            </ListItem>

          </React.Fragment>}

        </List>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          {t('buttons.close')}
        </Button>

        {(isSceneLabel) && <Button onClick={handleSubmit} color="primary">
          {t('buttons.save')}
        </Button>}
      </DialogActions>
    </Dialog>
  );
};

const TextDetectionParameters = (props) => {
  const {open, setOpen, runTextDetection, defaultScore, category} = props;

  const classes = useStyles();
  const {viewer} = useViewer();
  const {t} = useTranslation();

  const [spellcheck, setSpellcheck] = useState(false);
  const [score, setScore] = useState({
    value: defaultScore,
    error: false
  });

  const handleCancel = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    viewer?.setLabelFindText(category.id);
    runTextDetection(parseFloat(score.value), spellcheck);
    setOpen(false);
  };

  const resetDefaults = () => {
    setSpellcheck(false);
    setScore({value: defaultScore, error: false});
  };

  useEffect(() => {
    if (open) return;
    resetDefaults();
  }, [open]);

  const canSubmit = (!score.error);

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={open}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle>{t('labels.detect-text-in-name-labels', {
        name: category.name
      })}</DialogTitle>

      <DialogContent>

        {/* Classification Score */}
        <InputLabel>{t('labels.detection-score-threshold')}</InputLabel>
        <Typography variant="caption">
          {t('labels.detected-text-with-detection-scores-below')}
        </Typography>
        <NumberField
          className={classes.paddingBottom}
          data={score}
          setData={setScore}
          min={0.1}
          max={1.0}
          step={0.1}
        />

        {/* Spell check toggle */}
        <div className={classes.checkBoxWithLabel}>
          <InputLabel>{t('labels.spell-check-detected-text')}</InputLabel>
          <Checkbox
            checked={spellcheck}
            onChange={(event) => {
              setSpellcheck(event.target.checked);
            }}
            size="small"
            color="secondary"
          />
        </div>

        <Typography variant="caption">
          {t('labels.utilize-spell-checking')}
        </Typography>

      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          {t('buttons.cancel')}
        </Button>

        <Button onClick={handleSubmit} color="primary" disabled={!canSubmit}>
          {t('buttons.submit')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const ScoreSortingParameters = (props) => {
  const {open, setOpen, runSort, defaultScore, category} = props;

  const classes = useStyles();
  const {t} = useTranslation();

  const [sortType, setSortType] = useState('descending');
  const [score, setScore] = useState({
    value: defaultScore,
    error: false
  });

  const handleCancel = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    toast.success(t("toast.labels-sort-submit"));
    runSort(parseFloat(score.value), sortType);
    setOpen(false);
  };

  /*
  useEffect(() => {
    if (open) {
      return;
    }

    // Reset default values
    setSortType('descending');
    setScore({value: defaultScore, error: false});
  }, [open]);
  */

  const canSubmit = (!score.error);

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={open}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle>{t('labels.sort-name-labels', {
        name: category.name
      })}</DialogTitle>

      <DialogContent>

        {/* Classification Score */}
        <InputLabel>{t('labels.classification-score-threshold')}</InputLabel>
        <Typography variant="caption">
          {t('labels.classification-scores-below', {
            name: category.name
          })}
        </Typography>
        <NumberField
          className={classes.paddingBottom}
          data={score}
          setData={setScore}
          min={0.1}
          max={1.0}
          step={0.1}
        />

        {/* Sort Type */}
        <div>
          <InputLabel>{t('labels.sorting-method')}</InputLabel>
          <Typography variant="caption">
            {t('labels.choose-method-if-any-by-which-to-sort-the-category')}
          </Typography>

          <div>
            <Select
              value={sortType}
              fullWidth
              onChange={(event) =>{
                let value = event.target.value as any;
                setSortType(value);
              }}
            >
              <MenuItem value={"ascending"}>{t('labels.ascending-low-to-high')}</MenuItem>
              <MenuItem value={"descending"}>{t('labels.descending-high-to-low')}</MenuItem>
              <MenuItem value={"none"}>{t('labels.dont-sort')}</MenuItem>
            </Select>
            <FormHelperText>{" "}</FormHelperText>
          </div>
        </div>

      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          {t('buttons.cancel')}
        </Button>

        <Button onClick={handleSubmit} color="primary" disabled={!canSubmit}>
          {t('buttons.submit')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const ImageLabelling = memo((props: any) => {
  const {categoryList, trainingArea} = props;

  const classes = useStyles();
  const dispatch = useDispatch();
  const {viewer} = useViewer();
  const {t} = useTranslation();
  const imageLabelDialog = useDialog();
  const uniqueProjectID = useUniqueProjectID();
  const {activeToolOpen, setActiveToolOpen} = useActiveTool();

  const [labelType, setLabelType] = useState(null);
  const [addCategory, setAddCategory] = useState(false);
  const [classifyLasPrompt, setClassifyLasPrompt] = useState(false);
  const [closePrompt, setClosePrompt] = useState(false);
  const [importData, setImportData] = useState(null);
  const [labelLoadProgress, setLabelLoadProgress] = useState(0);
  const [classifyAerialProgress, setClassifyAerialProgress] = useState(0);
  const [trainClassifyProgress, updateTrainClassifyProgress] = useState(0);
  const [trainClassifyExe, setTrainClassifyExe] = useState(null);
  const [processType, setProcessType] = useState("");
  const [classifyImage, setClassifyImage] = useState(false);
  const [readingLabelFile, setReadingLabelFile] = useState(false);
  const [training, setTraining] = useState(false);
  const [trainingURL, setTrainingURL] = useState(null);
  const [downloadingResources, setDownloadingResources] = useState("");
  const [downloadResourcesDialog, setDownloadResourcesDialog] = useState("");
  const [trainingPrompt, setTrainingPrompt] = useState(false);
  const [classificationPrompt, setClassificationPrompt] = useState(false);
  const [labelExportOpen, setLabelExportOpen] = useState(false);
  const [textDetection, setTextDetection] = useState(false);
  const assets = useSelector(selectAllAssets);
  const cameraFiles = getCameraFileAssets(assets);
  const pointCloudFiles = getPointCloudAssets(assets);

  const isOrthoLabel = labelType === "ortho";
  const isSceneLabel = labelType === "scene";
  const numPanoramics = cameraFiles.filter(x => x.type === AssetType.Panoramic).length;
  const numPlanars = cameraFiles.filter(x => x.type === AssetType.Planar).length;
  const canExportCSV = isSceneLabel && (numPlanars === 0);

  // UI progress needs to be throttled, so it doesnt update too quickly and freeze the app
  const progressThrottleMilliseconds = 50;

  const setTrainClassifyProgress = useCallback(throttle(
    progressThrottleMilliseconds, (value) => {
      updateTrainClassifyProgress(value);
    }), []);

  const resetExecutableValues = () => {
    setTrainClassifyProgress(0);
    setTrainingURL(null);
    setDownloadingResources("");
    setTraining(false);
    setTextDetection(false);
    setClassifyImage(false);
  };

  const handleClose = () => {
    imageLabelDialog.handleClose();
    handleCancelProgress();
  };

  const checkClose = () => {
    if (isModified) {
      setClosePrompt(true);
    } else {
      handleClose();
    }
  };

  const isValidCategory = (name) => {
    // Uniqueness check
    const isUnique = viewer?.checkCategoryUniqueness(name);
    if (!isUnique) {
      toast.error(t("toast.labels-class-exists"));
      return false;
    }

    return true;
  };

  const handleCategoryChange = (state) => {
    setAddCategory(state);
  };

  const handleCancel = () => {
    handleCategoryChange(false);
  };

  const handleAddCategory = (name) => {
    if (!isValidCategory(name)) {
      return;
    }

    viewer?.addCategory(name);
    handleCategoryChange(false);
  };

  const handleCancelProgress = () => {
    trainClassifyExe?.destroy();
    resetExecutableValues();
  };

  const showTrainingWindow = (url) => {
    ipcRenderer?.send("show-training-window", url);
  };

  const stopTrainingWindow = () => {
    ipcRenderer?.send("stop-training-window");
  };

  const checkTrainingData = (jsonData) => {
    const canTrain = jsonData
      && (jsonData.annotations.length > 0)
      && (jsonData.images.length > 0);

    if (!canTrain) {
      toast.warning(t("toast.labels-not-active"));
    }

    return canTrain;
  };

  const exportImageLabels = () => {
    // No labels to export
    if (categoryList.length === 0) {
      toast.warning(t("toast.labels-not-created"));
      return;
    }

    dialog.showSaveDialog({
      defaultPath: viewer.projectName,
      filters: [
        ...labelFilter,
        ...(isOrthoLabel ? DXFModelFilter : []),
        ...(isOrthoLabel ? SHPModelFilter : [])
      ],
    }).then(result => {
      if (result.canceled) {
        return;
      }

      if (result.filePath) {
        const filePath = slash(result.filePath);
        const extension = path.extname(filePath);

        if (extension === ".dxf") {
          exportToLinework(filePath, extension, "dxf_path");
        }

        if (extension === ".shp") {
          exportToLinework(filePath, extension, "shp_path");
        }

        if (extension === ".3dl") {
          exportLabels3DL(filePath);
        }
      }
    }).catch(error => {
      console.log(error);
    });
  };

  /** @private */
  const exportLabels3DL = (filePath) => {
    const jsonData = viewer?.labelObject();

    let text = JSON.stringify(jsonData, null, 2);
    fs.writeFile(filePath, text, 'utf8', (err) => {
      if (err) {
        console.log(err);
        toast.error(t("toast.labels-export-failed"));
      }
      else {
        toast.success(t("toast.labels-export-to", {
          path: path.basename(filePath)
        }));

        console.log(`File written successfully to ${filePath}`);
      }
    });
  };

  /** @private */
  const exportToLinework = (filePath, extension, outputKey) => {
    const jsonData = viewer?.labelObject();
    if (!checkTrainingData(jsonData)) {
      return false;
    }

    // Write COCO file to temp path
    let text = JSON.stringify(jsonData, null, 2);
    let tempCocoPath = getTemporaryFile("3dl");

    try {
      fs.writeFileSync(tempCocoPath, text);
    } catch(err) {
      console.log(err);
      toast.error(t("toast.labels-export-failed"));
      return;
    }

    let pythonName;
    if (extension === ".dxf") {
      pythonName = "coco_to_dxf";
    } else if (extension === ".shp") {
      pythonName = "coco_to_shp";
    }

    if (!pythonName) {
      return;
    }

    let exe = new PythonExecutable();
    let commands = [
      "-p", pythonName,
      "--coco_path", tempCocoPath,
      `--${outputKey}`, filePath
    ];

    exe.run({
      command: commands,
      saveLogs: true,
      onClose: () => {
        toast.success(t("toast.labels-saved-linework", {
          type: extension,
          path: path.basename(filePath)
        }));
      }
    });
  };

  const importImageLabels = () => {
    const combinedExtension = getCombinedExtension(
      "dialog.supported-files", [
        labelFilter,
        modelFilter,
        isOrthoLabel ? drawingFilter : null
      ]);

    dialog.showOpenDialog({
      properties: ['openFile'],
      filters: [
        ...combinedExtension,
        ...labelFilter,
        ...modelFilter,
        ...(isOrthoLabel ? drawingFilter : [])
      ]
    }).then(result => {
      if (result.canceled) {
        return;
      }

      const filePath = slash(result.filePaths[0]);
      const extension = path.extname(filePath);

      if (extension === ".pth") {
        importLabelsPTH(filePath);
      }

      if (extension === ".3dl") {
        importLabels3DL(filePath);
      }

      const  importLinework =
        (extension === ".shp")
        || (extension === ".dxf")
        || (extension === ".zip");

      if (importLinework) {
        importLabelsLinework(filePath);
      }
    }).catch(error => {
      setReadingLabelFile(false);
      console.log(error);
    });
  };

  /** @private */
  const importLabelsPTH = (filePath) => {
    setReadingLabelFile(true);

    const exe = new PythonExecutable();

    let response;
    let commands = [
      "-p", "extract_coco_from_model",
      "--model_path", filePath,
    ];

    exe.run({
      command: commands,
      saveLogs: true,
      onLine: jsonData => {
        if (jsonData.downloading_resources) {
          setDownloadResourcesDialog("download");
        } else if (jsonData.extracting_resources) {
          setDownloadResourcesDialog("extract");
        } else if (jsonData.coco_data) {
          response = jsonData.coco_data;
        }
      },
      onClose: () => {
        setDownloadResourcesDialog("");

        if (response) {
          importLabelData(response);
        } else {
          toast.error(t("toast.labels-read-error"));
        }
      }
    });
  };

  /** @private */
  const importLabelsLinework = (filePath) => {
    setReadingLabelFile(true);

    const exe = new PythonExecutable();

    let response;
    let commands = [
      "-p", "convert_linework",
      "--input_paths", [filePath],
    ];

    exe.run({
      command: commands,
      onLine: jsonData => {
        if (jsonData.label_data) {
          response = {
            ...jsonData.label_data,
            projection: LocalScene.dataProjection
          };
        }
      },
      onClose: () => {
        importLabelData(response);
      }
    });
  };

  /** @private */
  const importLabels3DL = (filePath) => {
    try {
      const text = fs.readFileSync(filePath, 'utf8');
      const data = JSON.parse(text);
      importLabelData(data);
    } catch {
      toast.error(t("toast.labels-read-error"));
    }
  };

  /** @private */
  const importLabelData = (data) => {
    setReadingLabelFile(false);

    if (!data) {
      toast.error(t("toast.labels-read-error"));
      return;
    }

    if (data.type !== labelType) {
      toast.error(t("toast.labels-type-mismatch", {
        type: data.type
      }));
      return;
    }

    setImportData(data);
  };

  const forceInitialProgress = () => {
    setTrainClassifyProgress(0.001);
  };

  const cudaErrorDialog = (cudaError) => {
    const downloadURL = 'https://developer.nvidia.com/cuda-11.1.0-download-archive?target_os=Windows&target_arch=x86_64&target_version=10';

    dialog.showMessageBox({
      title: t("dialog.cuda-error-title"),
      message: t("dialog.cuda-error-message", {version: cudaError}),
      buttons: [
        t("buttons.dismiss"),
        t("buttons.get-cuda")
      ],
      type: 'error',
      noLink: true
    })
      .then(selection => {
        if (selection.response !== 1) return;
        shell.openExternal(downloadURL);
      });
  };

  const updateDownloadingResources = (jsonData) => {
    if (jsonData.downloading_resources) {
      setDownloadingResources("download");
    } else if (jsonData.extracting_resources) {
      setDownloadingResources("extract");
    } else {
      setDownloadingResources("");
    }
  };

  const canRunClassification = () => {
    const imagePaths = viewer?.loadedImageLabelPaths();
    const canClassify = imagePaths && (imagePaths.length > 0);

    if (!canClassify) {
      toast.warning(t("toast.labels-no-images"));
    }

    return canClassify;
  };

  const runClassification = (score, modelPath, runOnCPU) => {
    resetExecutableValues();
    setClassifyImage(true);

    let tempImagePath = getTemporaryFile("txt");
    let imageData = viewer.loadedImageLabelPaths();
    let imageJSON = JSON.stringify(imageData, null, 4);

    try {
      fs.writeFileSync(tempImagePath, imageJSON);
    } catch(err) {
      console.log(err);
      toast.error(t("toast.labels-classify-error"));

      setTraining(false);
      return;
    }

    try {
      let pythonName = isOrthoLabel
        ? "image_classification_orthomosaic"
        : "image_classification_panoramic";

      let commands = [
        "-p", pythonName,
        "--image_paths_txt", tempImagePath,
        "--output_folder", tempDirectoryPath,
        "--prediction_model", modelPath,
        "--proj_string", LocalScene.dataProjection,
        "--prediction_score_threshold", score,
        "--run_on_cpu", runOnCPU
      ];

      forceInitialProgress();

      let importData;
      let exe = new PythonExecutable();
      setTrainClassifyExe(exe);

      exe.run({
        command: commands,
        saveLogs: true,
        onLine: jsonData => {
          updateDownloadingResources(jsonData);

          if (jsonData.cudaError){
            cudaErrorDialog(jsonData.cudaError);
          }

          if (jsonData.progress) {
            setTrainClassifyProgress(jsonData.progress);
          } else if (jsonData.coco_data) {
            importData = jsonData.coco_data;
          }
        },
        onClose: async () => {
          if (importData) {
            toast.success(t("toast.labels-classify-loading"));

            await viewer.loadImageLabelData(
              importData,
              setLabelLoadProgress,
              true,
              false
            );

            toast.success(t("toast.labels-classify-loaded"));
          } else {
            toast.error(t("toast.labels-classify-error"));
          }

          resetExecutableValues();
        }
      });
    } catch {
      setClassifyImage(false);
      toast.error(t("toast.labels-classify-error"));
    }
  };

  const runTraining = (numIterations, outputPath, pretrainedModelPath, runOnCPU) => {
    resetExecutableValues();
    setTraining(true);

    let modelPath;
    let tempCocoPath = path.join(outputPath, "labels_for_training.3dl");
    let tempImagePath = getTemporaryFile("txt");

    try {
      const jsonData = viewer.labelObject();
      if (!checkTrainingData(jsonData)) {
        setTraining(false);
        return;
      }

      toast.success(t("toast.labels-train-submit"));

      let imageData = viewer.activeImageLabelPaths();
      let labelJSON = JSON.stringify(jsonData, null, 4);
      let imageJSON = JSON.stringify(imageData, null, 4);

      try {
        fs.writeFileSync(tempImagePath, imageJSON);
        fs.writeFileSync(tempCocoPath, labelJSON);
      } catch(err) {
        console.log(err);
        toast.error(t("toast.labels-export-failed"));

        setTraining(false);
        return;
      }

      forceInitialProgress();

      let pythonName = isOrthoLabel
        ? "image_training_orthomosaic"
        : "image_training_panoramic";

      let exe = new PythonExecutable();
      let commands = [
        "-p", pythonName,
        "--image_paths_txt", tempImagePath,
        "--output_folder", outputPath,
        "--coco_data_file", tempCocoPath,
        "--solver_max_iterations", numIterations,
        "--batch_size_per_image", 256,
        "--run_on_cpu", runOnCPU
      ];

      setTrainClassifyExe(exe);

      if (pretrainedModelPath) {
        commands = [
          ...commands,
          "--pretrained_model_pth",
          pretrainedModelPath
        ];
      }

      exe.run({
        command: commands,
        saveLogs: true,
        onLine: jsonData => {
          updateDownloadingResources(jsonData);
          if (jsonData.cudaError){
            cudaErrorDialog(jsonData.cudaError);
          } else if (jsonData.gpu_memory_error) {
            toast.error(t("toast.labels-train-error-memory"));
          } else if (jsonData.model_diverge_error){
            toast.error(t("toast.labels-train-error-diverge"));
          } else if (jsonData.label_bounds_error){
            toast.error(t("toast.labels-train-error-bounds"));
          } else if (jsonData.progress) {
            setTrainClassifyProgress(jsonData.progress);
          } else if (jsonData.model_file_path) {
            modelPath = jsonData.model_file_path;
          } else if (jsonData.url) {
            setTrainingURL(jsonData.url);
            showTrainingWindow(jsonData.url);
          } else if (jsonData.class_number_mismatch) {
            toast.error(t("toast.labels-train-error-class", {
              oldClasses: jsonData.old_classes.join(", "),
              newClasses: jsonData.new_classes.join(", ")
            }));
          }
        },
        onClose: () => {
          if (modelPath) {
            toast.success(t("toast.labels-train-complete", {
              path: modelPath
            }));
          } else {
            toast.warning(t("toast.labels-train-incomplete"));
          }

          stopTrainingWindow();
          resetExecutableValues();
        }
      });
    }
    catch (err ){
      console.log(err);
      setTraining(false);
      toast.error(t("toast.labels-train-error"));
    }
  };

  const runTextDetection = (score, spellcheck) => {
    resetExecutableValues();
    setTextDetection(true);

    let spellcheckCommand = spellcheck
      ? t('general.true')
      : t('general.false');

    let tempCocoPath = getTemporaryFile("3dl");
    let tempImagePath = getTemporaryFile("txt");

    try {
      const jsonData = viewer?.labelObject();
      if (!checkTrainingData(jsonData)) {
        setTextDetection(false);
        return;
      }

      let imageData = viewer.activeImageLabelPaths();
      let labelJSON = JSON.stringify(jsonData, null, 4);
      let imageJSON = JSON.stringify(imageData, null, 4);

      try {
        fs.writeFileSync(tempImagePath, imageJSON);
        fs.writeFileSync(tempCocoPath, labelJSON);
      } catch(err) {
        console.log(err);
        toast.error(t("toast.labels-export-failed"));

        setTextDetection(false);
        return;
      }

      let pythonName = "text_from_image";
      let commands = [
        "-p", pythonName,
        "--image_paths_txt", tempImagePath,
        "--coco_data_file", tempCocoPath,
        "--score_threshold", score,
        "--spell_check", spellcheckCommand
      ];

      forceInitialProgress();

      let importData;
      let exe = new PythonExecutable();
      setTrainClassifyExe(exe);

      exe.run({
        command: commands,
        saveLogs: true,
        onLine: jsonData => {
          updateDownloadingResources(jsonData);

          if (jsonData.cudaError){
            cudaErrorDialog(jsonData.cudaError);
          }

          if (jsonData.progress) {
            setTrainClassifyProgress(jsonData.progress);
          } else if (jsonData.coco_data) {
            importData = jsonData.coco_data;
          }
        },
        onClose: async () => {
          if (importData) {
            toast.success(t("toast.labels-text-loading"));

            await viewer.loadImageLabelData(
              importData,
              setLabelLoadProgress,
              true,
              false
            );

            toast.success(t("toast.labels-text-loaded"));
          } else {
            toast.error(t("toast.labels-text-error"));
          }

          resetExecutableValues();
        }
      });
    } catch {
      setTextDetection(false);
      toast.error(t("toast.labels-classify-error"));
    }
  };

  const canRunAerialToLas = () => {
    const LASfiles = pointCloudFiles.filter(x => x.type === AssetType.LAS);
    const visibleClouds = LASfiles.filter(x => x.visible);

    if (visibleClouds.length === 0) {
      toast.warning(t("toast.labels-no-clouds"));
    }

    if (!isModified) {
      toast.warning(t("toast.labels-no-categories"));
    }

    return isModified && (visibleClouds.length > 0);
  };

  useEffect(() => {
    /** Keep track if a tool is currently being used */
    setActiveToolOpen(imageLabelDialog.open);
  }, [imageLabelDialog.open]);

  useEffect(() => {
    /** Close dialog when new project is loaded */
    imageLabelDialog.handleClose();
  }, [uniqueProjectID]);

  useEffect(() => {
    registerEvent("open-label-ortho", () => {
      if (activeToolOpen) return toast.warning(t('toast.one_tool_only'));
      imageLabelDialog.handleOpen("ortho");
    });

    registerEvent("open-label-scene", () => {
      if (activeToolOpen) return toast.warning(t('toast.one_tool_only'));
      imageLabelDialog.handleOpen("scene");
    });
  }, [activeToolOpen]);

  useEffect(() => {
    if (!imageLabelDialog.open) return;

    const onKeyDown = event => {
      if (event.target instanceof HTMLInputElement) {
        return;
      }

      viewer?.labelHotkey(event);
    };

    window.addEventListener('keydown', onKeyDown, false);

    return () => {
      window.removeEventListener('keydown', onKeyDown, false);
    };
  }, [imageLabelDialog.open]);

  useEffect(() => {
    if (!viewer) return;
    viewer.setActiveLabelType(labelType);

    if (isOrthoLabel) {
      dispatch(changeSwitched(true));
    } else if (isSceneLabel) {
      dispatch(changeSwitched(false));
    }
  }, [viewer, labelType]);

  useEffect(() => {
    if (!viewer) return;
    setLabelType(imageLabelDialog.data);
  }, [viewer, imageLabelDialog.data]);

  useEffect(() => {
    if (classifyImage) {
      setProcessType("labels.image-classification");
    } else if (training) {
      setProcessType("labels.training");
    } else if (textDetection) {
      setProcessType("labels.text-detection");
    }

    if (trainClassifyProgress === 100) {
      setTrainClassifyProgress(0);
      setProcessType("");
    }
  }, [
    trainClassifyProgress,
    classifyImage,
    training,
    textDetection
  ]);

  const isModified = categoryList.length !== 0;
  const exportDisabled = viewer?.anyLabelSelected();
  const trainingLinkDisabled = trainingURL === null;
  const sceneTrainingDisabled = isSceneLabel
    && (numPanoramics > 0)
    && (numPlanars > 0);
  const categoryListDisabled = sceneTrainingDisabled;
  const hasTrainingArea = trainingArea.length > 0;

  const labelDisabled = (labelLoadProgress > 0)
    || training
    || classifyImage
    || textDetection;

  const localizedProcessType = t(processType);

  const modalName = isOrthoLabel
    ? t('labels.orthomosaic-training-classification')
    : t('labels.panoramic-training-classification');

  const downloadTooltip = downloadingResources
    ? ""
    : t('labels.running-process-on-dataset', {
      process: localizedProcessType
    });

  return (
    <React.Fragment>
      <DraggableDialog
        initialHeight={500}
        open={imageLabelDialog.open}
        title={modalName}
        onClose={checkClose}
      >
        {/* Label toolbar icons */}
        <IconToolBar margin={1}>

          {/* Add category */}
          <ToolBarButton
            title={t('labels.add-class')}
            icon={"fa-plus-circle"}
            onClick={() => handleCategoryChange(true)}
            success
            disabled={categoryListDisabled}
          />

          {/* Enable training areas */}
          <ToolBarButton
            title={t('labels.enable-training-areas')}
            icon={"fa-square-o"}
            visible={!hasTrainingArea && isOrthoLabel}
            onClick={() => {
              viewer?.addTrainingArea();
            }}
          />

          {/* Disable training areas */}
          <ToolBarButton
            title={t('labels.disable-training-areas')}
            icon={"fa-check-square-o"}
            visible={hasTrainingArea && isOrthoLabel}
            onClick={() => {
              viewer?.deleteTrainingArea();
            }}
          />

          {/* Run Training */}
          <ToolBarButton
            title={t('labels.run-training')}
            icon={"fa-train"}
            onClick={() => {
              setTrainingPrompt(true);
            }}
            disabled={categoryListDisabled || labelDisabled}
          />

          {/* Run Classification */}
          <ToolBarButton
            title={t('labels.run-classification')}
            icon={"fa-object-group"}
            onClick={() => {
              if (!canRunClassification()) {
                return;
              }

              setClassificationPrompt(true);
            }}
            disabled={categoryListDisabled || labelDisabled}
          />

          {/* Classify Las from Classes */}
          <ToolBarButton
            title={t('labels.classify-point-cloud-from-aerial')}
            icon={"fa-plane"}
            onClick={() => {
              if (!canRunAerialToLas()) {
                return;
              }

              setClassifyLasPrompt(true);
            }}
            visible={isOrthoLabel}
            disabled={categoryListDisabled || labelDisabled}
          />

          {/* Import label file */}
          <ToolBarButton
            title={t('labels.import-labels')}
            icon={"fa-upload"}
            onClick={importImageLabels}
            disabled={categoryListDisabled || exportDisabled || labelDisabled}
          />

          {/* Export Label file */}
          <ToolBarButton
            title={t('labels.export-labels')}
            icon={"fa-download"}
            onClick={exportImageLabels}
            disabled={categoryListDisabled || exportDisabled || labelDisabled}
          />

          {/* Export label intersects */}
          <ToolBarButton
            title={t('labels.label-analysis')}
            icon={"fa-file-excel-o"}
            visible={isSceneLabel}
            onClick={() => {
              if (!canRunClassification()) {
                return;
              }

              setLabelExportOpen(true);
            }}
            disabled={!canExportCSV || exportDisabled || labelDisabled}
          />

        </IconToolBar>

        <DenseDivider variant="middle" spacing={5}/>

        {(trainClassifyProgress > 0) && (<React.Fragment>

          <div className={classes.progressToolbar}>

            <ArrowTooltip title={downloadTooltip}>

              {/** Training/Classification progress */}
              <div className={classes.toolbarLinear} style={{
                flex: training ? 8 : 9,
              }}>
                <LinearProgressWithLabel
                  className={classes.toolbarProgressCenter}
                  variant="determinate"
                  value={trainClassifyProgress}
                  color="secondary"
                />
              </div>

            </ArrowTooltip>

            {/** Tensorbard training link */}
            {training && (
              <ToolBarButton
                title={t('labels.view-training-progress')}
                icon={"fa-line-chart"}
                disabled={trainingLinkDisabled}
                onClick={() => {
                  showTrainingWindow(trainingURL);
                }}
              />
            )}

            {/** Training/Classification cancel button */}
            <ToolBarButton
              title={t('labels.cancel-process', {
                process: localizedProcessType
              })}
              icon={"fa-ban"}
              onClick={handleCancelProgress}
              error
            />
          </div>


        </React.Fragment>)}

        {/** Downloading resources */}
        {(downloadingResources === "download") && (
          <Typography className={classes.downloadMargin} variant="caption" align="center">
            {t('labels.downloading-resources')} <CircularProgress size="1em"/>
          </Typography>
        )}

        {/** Extracting resources */}
        {(downloadingResources === "extract") && (
          <Typography className={classes.downloadMargin} variant="caption" align="center">
            {t('labels.extracting-resources')} <CircularProgress size="1em"/>
          </Typography>
        )}

        {sceneTrainingDisabled && (<Box className={classes.mixedDataWarning}>
          <Typography variant="caption" align="center">
            {t('labels.image-classification-is-not-supported-for-mixed-camera')}
          </Typography>
        </Box>)}

        {(numPlanars > 0) && (<Box className={classes.mixedDataWarning}>
          <Typography variant="caption" align="center">
            {t('labels.label-analysis-is-disabled-for-planar-images')}
          </Typography>
        </Box>)}

        {!categoryListDisabled && (<DialogContent className={classes.listContent}>
          <SlimScrollbar>
            {/** Training areas */}
            {hasTrainingArea && (<React.Fragment>
              <List className={classes.formControl}>
                {trainingArea.map(areas =>
                  <TrainingArea
                    key={areas.id}

                    trainingArea={areas}
                  />)}
              </List>

              <DenseDivider variant="middle" spacing={5}/>
            </React.Fragment>)}

            {/** Standard categories */}
            <List className={classes.formControl}>
              {categoryList.map(category =>
                <Category
                  key={category.id}
                  category={category}
                  isValidCategory={isValidCategory}
                  labelDisabled={labelDisabled}
                  runTextDetection={runTextDetection}
                  isSceneLabel={isSceneLabel}
                />)}
            </List>
          </SlimScrollbar>
        </DialogContent>)}

      </DraggableDialog>

      <TextDialog
        clear
        open={addCategory}
        onCancel={handleCancel}
        onSubmit={handleAddCategory}
        title={t('labels.create-new-class')}
        prompt={t('labels.enter-new-class-name')}
        label={t('labels.class-name')}
      />

      {/* Close modal */}
      <PromptDialog
        open={closePrompt}
        onCancel={() => setClosePrompt(false)}
        onSubmit={() => {
          handleClose();
          setClosePrompt(false);
        }}
        title={t('labels.close-classification-window')}
        prompt={t('labels.do-you-want-to-close-the-window', {
          name: modalName
        })}
        button={t('buttons.close')}
      />

      {/* Set training parameters */}
      <TrainingParameters
        open={trainingPrompt}
        setOpen={setTrainingPrompt}
        runTraining={runTraining}
        defaultIterations={'1000'}
      />

      {/* Set classification parameters */}
      <ClassificationParameters
        open={classificationPrompt}
        setOpen={setClassificationPrompt}
        runClassification={runClassification}
        defaultScore={'0.5'}
      />

      {/* Set classify from las parameters */}
      <ClassifyFromAerial
        open={classifyLasPrompt}
        setOpen={setClassifyLasPrompt}
        categories={categoryList}
        pointClouds={pointCloudFiles}
        setProgress={setClassifyAerialProgress}
      />

      {/* Image label import percent dialog */}
      <ProgressDialog
        open={classifyAerialProgress > 0}
        text={t('labels.applying_point_cloud_classification')}
        percent={classifyAerialProgress}
      />

      {/* Image label import percent dialog */}
      <ProgressDialog
        open={labelLoadProgress > 0}
        text={t('labels.importing-image-labels')}
        percent={labelLoadProgress}
      />

      <Dialog open={readingLabelFile}>
        <DialogContent className={classes.downloadResourceDialog}>
          <Typography className={classes.downloadMargin} variant="caption" align="center">
            {t('labels.reading-label-file')} <CircularProgress size="1em"/>
          </Typography>
        </DialogContent>
      </Dialog>

      <Dialog open={downloadResourcesDialog !== ""}>
        <DialogContent className={classes.downloadResourceDialog}>

          {/** Downloading resources (modal) */}
          {(downloadResourcesDialog === "download") && (
            <Typography className={classes.downloadMargin} variant="caption" align="center">
              {t('labels.downloading-resources')} <CircularProgress size="1em"/>
            </Typography>
          )}

          {/** Extracting resources (modal) */}
          {(downloadResourcesDialog === "extract") && (
            <Typography className={classes.downloadMargin} variant="caption" align="center">
              {t('labels.extracting-resources')} <CircularProgress size="1em"/>
            </Typography>
          )}

        </DialogContent>
      </Dialog>

      {/* Modal for importing linework data */}
      <ImportDialog
        importData={importData}
        setImportData={setImportData}
        categoryList={categoryList}
        isOrthoLabel={isOrthoLabel}
        setLabelLoadProgress={setLabelLoadProgress}
      />

      {/* Modal for exporting label intersections */}
      <LabelIntersectDialog
        open={labelExportOpen}
        setOpen={setLabelExportOpen}
        checkTrainingData={checkTrainingData}
        forceInitialProgress={forceInitialProgress}
        setTrainClassifyExe={setTrainClassifyExe}
        setTrainClassifyProgress={setTrainClassifyProgress}
        resetExecutableValues={resetExecutableValues}
        pointClouds={pointCloudFiles}
        categories={categoryList}
        setProcessType={setProcessType}
      />

    </React.Fragment>
  );
});
